import React, { Component } from "react";

import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withAppState, getAppState } from "../../state";
import { getSdk } from "../../services/sdkService";
import { config } from "../../config/config";
import {
  Title,
  NextEpisode,
  PauseScreen,
  EpisodesSelectorScreen,
  Tracks,
  Modal,
  Button,
  AdTag,
  Filmstrip,
  withFocusable,
  PlaybackRate,
  Loading,
  ControlsSettings,
  Controls,
  PauseAdScreen
} from "../../services/visualLibraryService";
import { PlayerShadow, ButtonSkipIntroStyled, PlayerShadowAds } from "../Player/styles/Styled";
import {
  playerUiStates,
  changeState,
  onStateEnter,
  setPlayerLoadTimer,
  destroyPlayerLoadTimer,
  showPlayer,
  hidePlayer
} from "../Player/playerStates";
import { WIDEVINE_FORMATS, DPLAY } from "../../utils/epgUtil";
import { getLogger } from "../../utils/logger";
import FreeLogo from "../../components/FreeLogo";
import { updateTracksState, extendTrackInfo } from "../Player/tracks";
import { checkDevice, sendMaxDevicesReport } from "../Player/devices";
import { getPlayerErrorMessage, getPlayerErrorMessageHeading, sendPlayerErrorReport } from "../Player/playerErrors";
import { getSeasonsAndEpisodesList, getVideoData } from "../../utils/mediaDataRetrieval";
import { sendUserEvent, trackEvent } from "../../services/analyticsService";
import { isFVODFreeToAir } from "../../utils/fvodUtils";
import { Player, PlayerEvent } from "bitmovin-player";
import { SubtitleOverlay, SeekBar, UIContainer, UIManager } from "bitmovin-player-ui";
import { i18n, directions } from "../../services/i18nService";
import { resolution } from "../../config/ui/resolutionConfig";
import { getEpisodeLabel } from "../../services/copyService";
import {
  showContentNotAccessibleModal,
  showForceLogoutError,
  showNotLoggedModal,
  showQRCodeModal,
  showVideoCommerceModal
} from "../../services/modalsService";
import { getErrorCode, createErrorMapper, normalizeLang } from "./bitmovinErrorMapper";
import { getUserMediaLists, myListHandler, checkMediaListsData } from "../../services/mediaListService";
import {
  requestAdPostCall,
  requestAdGetCall,
  parseTrackerCallData,
  getVideoCommerceData,
  timeToSeconds,
  isValidTime,
  getCurrentUTCTimestamp
} from "./adApiCalls";
import { getTVODInitStatus, getBrandsName } from "../../utils/tvodUtils";
import { isGuestUserLoggedIn, getGuestUserID } from "../../utils/guestProfileUtil";
import "./style.css";
import {
  Wrapper,
  PlayerDiv,
  LowerPlayerControls,
  LowerPlayerControlsAds,
  PlayPauseToggle,
  ToggleBtn,
  FillBtnPlay,
  FillBtnPause,
  CurrentPlay,
  TotalPlayTime,
  CurrentAndTotalPlaySpan,
  ProgressBarContainer,
  ProgressBar,
  ProgressBarContainerAd,
  ProgressBarAd,
  ControlsSettingsStyled,
  LabelDiv,
  LabelStyled,
  ControlSettingsBtn,
  ButtonsAdsStyled,
  FillBtnBack,
  FillBtnLanguage,
  FillBtnStart,
  FillBtnEpisode,
  AdInfoStyled,
  AdTextStyled,
  AdBreaksListStyled,
  AdBreaksStyled,
  AdDotStyled,
  ButtonRemoveAdStyled
} from "./styled";
import { ButtonStyled } from "../../components/ModalSettings/styles/Styled";
import VideoCommerceList from "../../components/VideoCommerceList";
import { SkipAdButton } from "./styled";
import { isAvodAssets } from "../../services/titleDataService";
import { isChampionsTrophyAddOn, showSubscriptionModal } from "../../utils/subscriptionUtils";
import {
  getYouboraParamsForBytePlus,
  sendVideoPlayClickEventDataForBytePlus,
  sendTrueViewImpressionForBytePlus,
  sendStayEventForBytePlus,
  extractHisenseVersion,
  getContentTypeForAnalytics
} from "../../services/byteEventService";
import { getWidevineURL } from "../../services/configService";
import throttle from "../../helpers/throttle";
import { getPauseAd, impressionTracking } from "../../services/sponsorAdService";
import {
  getConcurrency,
  getSuperParentAddOnNameForConcurrency,
  isInitiateConcurrencyFlow
} from "../../utils/concurrencyUtils";
import { makeBaseContentAsStarzplay } from "../../utils/commonUtils";
import { getSignatureKeyV1 } from "../../services/tvodService";

import { generateSignatureSHA512 } from "../../utils/encodingUtil";
import { getStreamingURL, isEnableNoDrm } from "../../services/mediaService";
import { parseQueryString } from "../../helpers/parseQueryString";
import { getCurrentProfile } from "../../services/multipleProfilesService";
import { getAddonsListWithBase } from "../../services/layoutService";
import { getDeviceName } from "../../utils/mobileLiteUtils";
import { setHeartBeatTimer } from "../../services/heartbeatService";

let sdk = null;
let nextEpisodeData = null;
let playbackToken = "";
let playbackTokenNonDRM = "";
let locationState;
let Logger;
const PLAY_FROM_NEXT_EPISODE = "player_next_episode";
const PLAY_FROM_EPISODE_SELECTOR = "player_episode_selector";
const SKIP_INTRO_BUTTON_FOCUS_PATH = "skipIntroButton";
const SKIP_OUTRO_DISMISS_BUTTON_FOCUS_PATH = "skipOutroDismissButton";
const BUTTON_DISMISS_OUTRO_FOCUS_PATH = "buttonDismissOutroFocusPath";
const SEND_TO_PHONE = "SendToPhone";
const SEND_TO_PHONE_ICON_FOCUS = "send_to_phone_focused";
const SEND_TO_PHONE_ICON = "send_to_phone";
const SKIP_AD = "SkipAd";
const SKIP_AD_ICON_FOCUS = "skip_ad_focused";
const SKIP_AD_ICON = "skip_ad";
const DISCONNECTIVIITY_INTERNET_ERROR_CODE = "571145";
const EPISODEFOCUS = "episodesCarousel";
const SEASONFOCUS = "seasonsCarousel";
const PAUSE_AD_FOCUS = "playerThumbnail";
const PAUSE_AD_BUTTON_FOCUS = "visitSite";
const CLOSE_BUTTON_FOCUS = "globalModalCloseFocusPath_passThru";
const LOGIN_MODEL_FOCUS = "globalModalLoginFocusPath_passThru";
const SIGNUP_MODEL_FOCUS = "globalModalSectionSignupFocusPath_passThru";
const CANCEL_MODEL_FOCUS = "globalModalCancelFocusPath_passThru";
const CONTINUE_MODEL_FOCUS = "globalModalContinueFocusPath_passThru";
const FOCUS_ON_CARDS = "videoCommerceCard";
const AVOD = "AVOD";
const TVOD = "TVOD";
const FVOD = "FVOD";
const RENT = "RENT";
const BUY = "BUY";
const FilmstripFocus = withFocusable(Filmstrip);
const AdButtonFocus = withFocusable(Button);
const AdButtonRemoveFocus = withFocusable(Button);
const SkipAdButtonFocus = withFocusable(SkipAdButton);
const ButtonSkipIntroFocus = withFocusable(ButtonSkipIntroStyled);
const ButtonFocus = withFocusable(ButtonStyled);
const defaultFocusPath = "video";
const STUFFSKIPAD = 0;
const STUFFSKIPADONLAST = 3;
const PLAY_FROM_START = "buttonRestart";
const PLAY_FROM_RESUME = "buttonPlay";
const VC = "VIDEO_COMMERCE";
const DELAY_TIMEOUT = 3000;
const REMOVE_AD_BUTTON = "removeAdButton";
const REMOVE_AD_PAUSE_BUTTON_FOCUS_PATH = "removeAdButtonPauseAd";
const VAULTO_CALL_ERROR_CODE = "571144";
const NODRM_CALL_ERROR_CODE = "571143";

var hidden, visibilityChange;

if (typeof document.hidden !== "undefined") {
  // To support the standard web browser engine
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  // To support the webkit engine
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}
class PlayerBitMovin extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    sdk = getSdk();
    Logger = getLogger();
    sdk.playerManager.destroy();
    locationState = this.props.location.state;
    this.state = {
      player: null,
      isPlayerLoaded: false,
      isPlaying: true,
      isSeeked: false,
      seekedTime: 0,
      duration: "00:00",
      currentTime: "00:00",
      currentTimeInSeconds: 0,
      totalTimeInSeconds: 0,
      showPauseScreen: false,
      playbackRate: 0,
      margin: i18n.getDirection() === "ltr" ? 2 : 1,
      selectBtn: locationState.isLive ? 1 : 0,
      selectFocusBtnAdRemoved: false,
      totalBtns:
        locationState.videoType === "series"
          ? 4
          : locationState.videoType === "trailer"
          ? 1
          : locationState.isLive
          ? 2
          : 3,
      textLabels:
        locationState.videoType !== "trailer"
          ? [
              "",
              i18n.get("global.back"),
              i18n.get("pages.player.settings.audioSubtitles"),
              i18n.get("global.playFromBeginning"),
              i18n.get("global.media.episodes")
            ]
          : ["", i18n.get("global.back")],
      playerBuffering: true,
      episodeSelectorLoading: false,
      openTracksAndAudio: false,
      showFilmStrip: false,
      subtitleTracks: null,
      audioTracks: null,
      filmstripData: null,
      nextEpisodePlay: false,
      skipIntroPlay: false,
      skipOutroPlay: false,
      isPlayFromStart: false,
      currentSubtitleID: null,
      isMaxDeviceReached: false,
      showPlayerControls: true,
      isPlayFromEpisodes: false,
      showEpisodesLists: false,
      errorMessage: null,
      errorMessageHeading: null,
      isTryToplayFromResume: true,
      title: locationState.title,
      seriesTitle: locationState.seriesTitle,
      episodeLabel: locationState.episodeLabel,
      description: locationState.description,
      tvSeasonNumber: locationState.tvSeasonNumber,
      tvSeasonEpisodeNumber: locationState.tvSeasonEpisodeNumber,
      skipOutroCountDown: this.checkOutroTime(),
      nextEpisodeCountDown: this.checkNextEpTime(),
      isFreePlaybackEnded: false,
      stayEventCalledFromPlayerErr: false,
      lastStayEventSentFor: ""
    };

    this.config = {
      refCanStartPlayback: null
    };
    this.wheelState = "idle";
    this.requestAdUrl = null;
    this.trackingHostUrl = null;
    this.manifestHostUrl = null;
    //tracks load
    this.hasLoadedTracks = false;

    this.isForcedAd = false;
    this.isForcedAdFomCW = false;
    this.isForcedAdIndex = 0;
    this.isPlayfromStartCW = false;
    this.filterAdData = [];
    this.adBreaksStartTimes = [];
    this.adBreaksEndTimes = [];
    this.adBreaksIndexes = [];
    this.adMargin = [];
    this.adBreakCounter = 0;
    this.storedSeekedTime = 0;
    this.adCounter = 0;
    this.adDuration = "00:00";
    this.totalAdsInAdBreak = 0;
    this.adDurationinSeconds = 0;
    this.adDurationSetTimeInterval = 0;
    this.isAdUIShown = false;
    this.isAdbreakFinish = false;
    this.hasDefaultAdUIFocus = false;
    this.adSeekTime = 0;
    this.retryCount = 0;
    this.adTimeInterval = null;
    this.isAdStalled = false;
    this.adRoutingURL = "";
    this.showQRCodeModal = false;
    this.isSkipBtnDisabled = true;
    this.skipOffset = null;
    this.isLivePlayBackStart = false;
    this.isSkipable = false;
    this.isPlayFromAds = false;
    this.adCountry = getAppState().country.toUpperCase();
    this.isRemoveAdPopupOpen = false;
    this.currentAdData = null;
    this.isAdStarted = true;
    this.isAdSkipped = false;
    this.totalSkipOutroTimeAdjusmentInSeconds = 0;
    this.skipDisableTimer = null;

    // concurrency
    this.isAllowPlayback = null;
    this.concurrency = 0;

    // Video Commerce
    this.videoCommerceData = null;
    this.filteredVCData = [];
    this.videoCommerceTimes = [];
    this.showVideoCommerceUI = false;
    this.adBreakEndTime = 0;

    // Remove Ads
    this.isAdRemoved = false;

    this.playbackPercentages = [...config.get().player.playbackPercentages];
    this.timeToHideUI = config.get().player.timeToHideUI;
    this.timeToShowPauseScreen = config.get().player.timeToShowPauseScreen;
    this.xRequestId = "";

    createErrorMapper();
    this.filmstrip = null;
    this.dismissClicked = false;
    this.errorButtonClose = null;
    this.isNextEpisodeRequested = false;
    this.dismissOutroInterval = null;
    this.showPauseScreenInterval = null;
    this.showHidePlayerControls = null;
    this.previousSecond = null;
    this.playbackTimes = null;
    this.appFlow = i18n.getDirection(); //LTR or RTL
    this.playbackIconName = "";
    this.isHeartBeatLoaded = null;
    this.bindings();

    document.addEventListener(visibilityChange, this.onVisibilityChange);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activePanel !== this.state.activePanel) {
      Logger.log(PlayerBitMovin.getPlayerLog(this.state), "Player");
      if (onStateEnter[this.state.activePanel]) {
        onStateEnter[this.state.activePanel].call(this);
      }
      this.updateFocus();
    }
  }

  async checkMaxDevices() {
    const { maxDevices } = config.get().featureToggles;

    if (maxDevices && locationState.videoType !== "trailer") {
      try {
        const { freeDeviceSlotsExist, maximumDevicesAllowed, deviceAlreadyRegistered } = await checkDevice.call(this);
        if (!freeDeviceSlotsExist && !deviceAlreadyRegistered) {
          this.showErrorModal(i18n.get("pages.player.errors.maximumDevicesReached", maximumDevicesAllowed));
          sendMaxDevicesReport.call(this);
          return true;
        }
      } catch (e) {
        await this.props.stateActions.setForceLogout({ status: e.code });
        // if Force logout show the popup
        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
        this.showErrorModal(e.message);
        return true;
      }
    }
    return false;
  }

  async componentDidMount() {
    sdk = await getSdk();
    this.retryCount = 0;
    if (locationState.playFrom === "cw_home") {
      await this.loadContent();
    }
    await this.updateConfig();
    (async () => {
      try {
        if (getAppState().userLogged && locationState?.contentType !== AVOD) {
          const isMaxDevice = await this.checkMaxDevices();
          this.setState({ isMaxDeviceReached: isMaxDevice });
        }

        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
        if (this.state.isMaxDeviceReached === true) {
          return;
        }
        const isDisableRemoveAdFlow =
          locationState?.contentType === TVOD ||
          locationState?.contentType === RENT ||
          locationState?.contentType === BUY ||
          locationState?.contentType === FVOD;
        if (!this.props.applicationState.isSvodUser && !isDisableRemoveAdFlow) {
          this.isAdRemoved = true;
        }
        let { onRef } = this.props;
        showPlayer();
        this.clearUserMediaCached();
        onRef(this);
        if (locationState.playFrom === "cw_home") {
          await this.loadContent();
        }
        if (locationState.videoType === "series") {
          if (!locationState.seasonsList && !locationState.episodesList) {
            await this.checkAndLoadSeriesData();
          }
        }
      } catch (e) {
        await this.props.stateActions.setForceLogout(e);
        // if Force logout show the popup
        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
        this.showErrorModal(e.message);
        return;
      }
      try {
        Logger.log(this.config.manifest, "Manifest");
        // byte+
        var bytePlusYouboraData = await getYouboraParamsForBytePlus({
          titleId:
            locationState?.videoType == "movie" || locationState?.videoType == "trailer"
              ? locationState?.id
              : locationState?.seriesId
        });
        this.config = { ...this.config, ...bytePlusYouboraData };
        this.setupPlayer();
      } catch (e) {
        Logger.log(
          `Requesting error message for error: ${e.code} after failure in playerManager.setup`,
          "Player.componentDidMount"
        );
      }
      document.addEventListener("keyup", this.handleRemoteKeys, false);
      document.addEventListener("keydown", this.handleRemoteKeysFilmstrip, false);
      !!getAppState().globalModal && this.props.stateActions.hideGlobalModal();

      const seriesTitle = locationState.seriesId ? locationState.seriesTitle : null;

      this.config.playbackAnalytics = {
        ...this.config.playbackAnalytics,
        title: seriesTitle || this.state.title
      };
    })();
  }

  componentWillUnmount() {
    if (this.state.isMaxDeviceReached === false) {
      document.removeEventListener("keyup", this.handleRemoteKeys, false);
      document.removeEventListener("keydown", this.handleRemoteKeysFilmstrip, false);
      sessionStorage.setItem("fromEpg", "no");
      hidePlayer();
      this.filterAdData = [];
      this.adBreaksStartTimes = [];
      this.adBreaksEndTimes = [];
      this.adBreaksIndexes = [];
      sdk.playerManager.stop(false);
      sdk.playerManager.destroy();
      //Removing all Event Handlers
      if (this.player && this.player !== null) {
        this.player.off(PlayerEvent.Seek, this.seekEventHandler);
        this.player.off(PlayerEvent.Playing, this.playEventHandler);
        this.player.off(PlayerEvent.PlaybackFinished, this.playbackFinishedEventHandler);
        this.player.off(PlayerEvent.TimeChanged, this.timeChangedEventHandler);
        this.player.off(PlayerEvent.Error, this.playerErrorEventHandler);
        this.player.off(PlayerEvent.StallStarted, this.stallStartedEventHandler);
        this.player.off(PlayerEvent.StallEnded, this.stallEndedEventHandler);
        document.removeEventListener(visibilityChange, this.onVisibilityChange);
        this.resetAdsPlayer();
      }
      this.player && this.player.off(PlayerEvent.Seeked, this.seekedHandler);
      destroyPlayerLoadTimer.call(this);
      this.player && this.player.unload();
      this.player && this.player.destroy();
      this.player && this.props.resumeNavigation();
    }
    localStorage.removeItem("isThisSeriesHasFreeEpisodes");
    this.videoCommerceData = null;
  }

  resetAdsPlayer() {
    clearInterval(this.adTimeInterval);
    clearTimeout(this.skipDisableTimer);
    this.filterAdData = [];
    this.adBreaksEndTimes = [];
    this.adBreaksIndexes = [];
    this.currentAdData = null;
    this.isAdStarted = true;
    this.adBreakCounter = 0;
    this.adCounter = 0;
    this.adDuration = "00:00";
    this.totalAdsInAdBreak = 0;
    this.adDurationinSeconds = 0;
    this.adDurationSetTimeInterval = 0;
    this.isAdUIShown = false;
    this.isAdbreakFinish = false;
    this.adSeekTime = 0;
    this.adTimeInterval = null;
    this.isPlayBackStart = false;
    this.isSkipBtnDisabled = true;
    this.skipOffset = null;
    this.totalSkipOutroTimeAdjusmentInSeconds = 0;
    this.filteredVCData = [];
    if (!this.videoCommerceData) {
      this.adBreaksStartTimes = [];
      this.adMargin = [];
    }

    this.storedSeekedTime = 0;
    this.isForcedAd = false;
    this.isForcedAdFomCW = false;
    this.isForcedAdIndex = 0;
  }

  resetAdbreak() {
    setTimeout(() => {
      this.adCounter = 0;
      this.adDurationinSeconds = 0;
      this.adSeekTime = 0;
    }, DELAY_TIMEOUT);
    this.isAdbreakFinish = false;
    this.hasDefaultAdUIFocus = false;
    clearInterval(this.adTimeInterval);
    this.adTimeInterval = null;
    this.isSkipBtnDisabled = true;
    clearTimeout(this.skipDisableTimer);
  }

  /** returns ads country right */

  async getAdsCountryRightsData(seasonNumber = 1, episodeNumber = 1) {
    const episodesList = this.getEpisodesList();
    const episodeIndex = episodesList.findIndex(
      title => episodeNumber === title.tvSeasonEpisodeNumber && seasonNumber === title.tvSeasonNumber
    );
    return episodesList[episodeIndex].adsCountryRights || [];
  }

  /** return episode tags */

  async getFreeEpisodeTag(seasonNumber = 1, episodeNumber = 1) {
    let episodesList = this.getEpisodesList();
    if (episodesList.length === 0) {
      await this.checkAndLoadSeriesData();
      episodesList = this.getEpisodesList();
    }
    const episodeIndex = episodesList.findIndex(
      title => episodeNumber === title.tvSeasonEpisodeNumber && seasonNumber === title.tvSeasonNumber
    );
    return (episodesList[episodeIndex] && episodesList[episodeIndex].tags) || [];
  }

  /**
   * Request content for playback (only when come to the player from the CW of the Layout)
   */
  async loadContent() {
    const { id, progress, seriesId, moduleId, is4K, contentType, onlineContent } = locationState.videoConfig;
    try {
      const videoData = await getVideoData(id, progress, seriesId, moduleId, is4K, contentType, onlineContent);
      sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
      Object.assign(locationState, videoData);
      this.setState({
        title: locationState.title,
        seriesTitle: locationState.seriesTitle,
        episodeLabel: locationState.episodeLabel,
        description: locationState.description,
        tvSeasonNumber: locationState.tvSeasonNumber,
        tvSeasonEpisodeNumber: locationState.tvSeasonEpisodeNumber
      });
    } catch (e) {
      await this.props.stateActions.setForceLogout(e);
      // if Force logout show the popup
      if (!!getAppState().forceLogout) {
        this.props.resumeNavigation();
        await showForceLogoutError.call(this);
        return;
      }
    }
    await this.updateConfig();
    let resumeFrom = this.config.playbackTime !== 0 ? this.config.playbackTime : 0;
    if (resumeFrom && resumeFrom !== 0 && this.state.isTryToplayFromResume === true) {
      this.setState({
        currentTime: this.toMinutesAndSeconds(resumeFrom)
      });
    }
  }

  /**
   * Updates config information to send to the player
   */
  async updateConfig() {
    const { isActiveUser } = this.props.applicationState;
    Object.assign(this.config, {
      releasePids: locationState.releasePid,
      releaseUrl: locationState.releaseUrl,
      videoType: locationState.videoType,
      contentTypeYoubora: locationState.contentTypeYoubora,
      dash_widevine_ads: locationState.dash_widevine_ads,
      dPlay: locationState.dPlay,
      manifest: locationState.manifest,
      adsCountryRights: locationState.adsCountryRights,
      playbackTime: locationState["playbackTime"],
      id: locationState.id,
      has4K: locationState.has4K,
      externalSubtitles: locationState.externalSubtitles,
      isLive: locationState.isLive,
      freeToAir:
        locationState.videoType === "series"
          ? !isActiveUser &&
            isFVODFreeToAir(
              await this.getFreeEpisodeTag(locationState.tvSeasonNumber, locationState.tvSeasonEpisodeNumber)
            )
          : null,
      autoplay: false,
      assetType: this.isPlayFromAds ? WIDEVINE_FORMATS.withAd : WIDEVINE_FORMATS.withoutAd,
      contentType: locationState.contentType,
      contentOwnership: locationState.contentOwnership || "",
      profileType: locationState.profileType,
      userid: isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId"),

      package: makeBaseContentAsStarzplay(locationState.addonContent),
      deviceType: config.get().sdk.deviceType,
      isFirstPlay: getTVODInitStatus(),
      addonContent: locationState.addonContent || "starz",
      onlineContent: locationState.onlineContent || "online",
      ...(config.get().featureToggles.skipIntro &&
        locationState.videoType === "series" && {
          credits: locationState.credits
        }),
      playbackAnalytics: {
        season: locationState.tvSeasonNumber || 0,
        episode: locationState.tvSeasonEpisodeNumber || 0,
        mediaGuid: locationState.playbackAnalytics
          ? locationState.playbackAnalytics.mediaGuid
          : locationState.mediaGuid,
        duration: locationState.duration,
        genre: locationState.genre,
        is4KEnabled: this.is4KSessionSelectedQuality() && locationState.has4K,
        playFrom: locationState.playFrom,
        resume: !!locationState["playbackTime"],
        title: locationState.seriesTitle || this.state.title
      }
    });

    if (locationState.videoType === "series") {
      if (locationState.seriesId) {
        this.config.seriesId = locationState.seriesId;
      }
      this.config.seasonNumber = locationState.tvSeasonNumber || 1;
      this.config.episodeNumber = locationState.tvSeasonEpisodeNumber || 1;
    }
  }
  showProgressBar() {
    if (this.state.showPauseScreen === true) {
      this.setState({
        showPauseScreen: false
      });
    }
    !this.showVideoCommerceUI && !this.QRCodeModal && this.showControls();
  }

  showBar() {
    clearTimeout(this.showHidePlayerControls);
    this.setState({
      showPlayerControls: true
    });
  }

  subtitlesUIAdjust() {
    const subtitleLabel = document.querySelector(".bmpui-player-state-playing .bmpui-ui-subtitle-overlay");
    if (subtitleLabel && this.showVideoCommerceUI) {
      subtitleLabel.classList.add("subtitle-overlay-adjust");
    } else {
      subtitleLabel.classList.remove("subtitle-overlay-adjust");
    }
  }

  showControls() {
    clearTimeout(this.showHidePlayerControls);
    this.setState({
      showPlayerControls: true
    });
    if (!this.state.showFilmStrip) {
      this.showHidePlayerControls = setTimeout(() => {
        this.setState({
          showPlayerControls: false,
          openTracksAndAudio: false,
          selectFocusBtnAdRemoved: false,
          selectBtn: 0
        });
      }, this.timeToHideUI);
    }
  }

  backHandler() {
    this.player && this.player.pause();
    locationState.videoType !== "trailer" && this.state.totalTimeInSeconds && this.checkPercentageTimePlayed();
    locationState.videoType == "trailer" && this.checkPercentageTimePlayed(true);
    sdk.playerManager.destroy();

    setTimeout(() => {
      this.props.history.goBack();
    }, 100);
  }

  back() {
    this.player && document.removeEventListener("keyup", this.handleRemoteKeys, false);
    this.player && document.removeEventListener("keydown", this.handleRemoteKeysFilmstrip, false);
    this.backHandler();
  }

  maxDeviceBack() {
    sdk.playerManager.destroy();
    setTimeout(() => this.props.history.goBack(), 100);
  }

  resetTracks() {
    this.setState({
      audioTracks: null,
      subtitleTracks: null
    });
  }

  openLanguage() {
    this.setState({
      openTracksAndAudio: true
    });
  }

  playFromBegining() {
    this.playFromStart();
  }
  async updateEpisodeProgress() {
    await getUserMediaLists(locationState?.seriesId, checkMediaListsData.bind(this), true);

    const watchlist = this.props.applicationState?.userMediaCached?.media_lists?.find(
      list => list.name === "watchlist"
    );
    if (!watchlist?.titles) return;

    const episodesList = locationState?.episodesList?.length
      ? locationState.episodesList
      : this.state?.episodesList?.length
      ? this.state.episodesList
      : [];

    const progressMap = {};
    watchlist.titles.forEach(t => {
      const key = `${t.tvSeasonNumber}_${t.tvSeasonEpisodeNumber}`;
      progressMap[key] = t.progress;
    });
    const updatedEpisodesList = episodesList.map(ep => {
      const key = `${ep.tvSeasonNumber}_${ep.tvSeasonEpisodeNumber}`;
      return progressMap.hasOwnProperty(key) ? { ...ep, progress: progressMap[key] } : ep;
    });
    if (locationState?.episodesList?.length) {
      locationState.episodesList = updatedEpisodesList;
    } else {
      this.setState({ episodesList: updatedEpisodesList });
    }
  }

  async openEpisodeList() {
    this.setState({
      openTracksAndAudio: false,
      showPlayerControls: false,
      showFilmStrip: false
    });
    // episodes button
    this.setState({
      showEpisodesLists: true,
      playerBuffering: true
    });
    this.player.pause();
    getAppState().playbackPausedTime = new Date().getTime();
    sdk.playerManager.pause();
    const self = this;

    await this.updateEpisodeProgress();

    setTimeout(() => {
      self.props.setFocus(EPISODEFOCUS);
    }, 500);

    this.setState({ playerBuffering: false }, () => {
      changeState.call(this, playerUiStates.EPISODE_SELECTOR);
    });
    //byte+
    if (locationState?.videoType == "series") {
      let tvS = locationState?.tvSeasonNumber;
      if (tvS) {
        this.seasonChanged(tvS - 1);
      }
    }
    // locationState?.videoType=="series" && sendTrueViewImpressionForBytePlus({ carouselContents: locationState?.episodesList, currentScreen:sessionStorage?.getItem("currentScreen"), previousScreen:sessionStorage?.getItem("prevScreen") })
  }

  async checkAndLoadSeriesData() {
    const seriesData = await getSeasonsAndEpisodesList(locationState.seriesId);
    this.setState({ playerBuffering: false, ...seriesData }, () => {
      changeState.call(this, playerUiStates.EPISODE_SELECTOR);
    });
  }

  async handleRemoteKeys(event) {
    const { isLive } = locationState;
    this.wheelState = "idle";
    const stopNavOnFocusPath = [LOGIN_MODEL_FOCUS, SIGNUP_MODEL_FOCUS, CANCEL_MODEL_FOCUS, CONTINUE_MODEL_FOCUS];
    const isBlocked = () =>
      this.state.playerBuffering ||
      this.state.nextEpisodePlay ||
      this.state.skipOutroPlay ||
      this.shouldShowLoading() ||
      this.showVideoCommerceUI ||
      stopNavOnFocusPath.includes(this.props.applicationState.currentFocus);

    if (isBlocked()) return;
    if (event.keyCode === 13) {
      // OK button
      if (this.state.showEpisodesLists || this.state.openTracksAndAudio) return;
      // if Focus is on video cards disable player controls
      if (this.isAdUIShown === true && locationState.isLive) {
        if (sessionStorage.getItem("fromEpg") === "yes") {
          if (this.props.applicationState.currentFocus === CLOSE_BUTTON_FOCUS) {
            this.closeModal(SEND_TO_PHONE);
            return;
          } else {
            this.openADSponsorAction();
            return;
          }
        }
      }
      if (this.isAdUIShown === false) {
        if (this.showQRCodeModal) {
          this.closeModal();
        }
        if (this.isRemoveAdPopupOpen) {
          this.isRemoveAdPopupOpen = false;
          return;
        }
        if (this.state.skipIntroPlay === true) {
          this.skipIntroAction();
          return;
        }
        if (
          this.state.selectBtn === 0 &&
          !this.dismissClicked &&
          this.props.applicationState.currentFocus !== SKIP_AD &&
          this.props.applicationState.currentFocus !== PAUSE_AD_BUTTON_FOCUS &&
          this.props.applicationState.currentFocus !== CLOSE_BUTTON_FOCUS &&
          this.props.applicationState.currentFocus !== "nextEpisode" &&
          this.props.applicationState.currentFocus !== "buttonBackNextEpisode" &&
          this.props.applicationState.currentFocus !== REMOVE_AD_PAUSE_BUTTON_FOCUS_PATH
        ) {
          if (this.state.selectFocusBtnAdRemoved) {
            await this.removeAdAction();
          } else if (!this.state.selectFocusBtnAdRemoved) {
            await this.togglePausePlay();
          }
        } else if (!this.state.showFilmStrip && this.state.selectBtn === 1) {
          this.backHandler();
          // back button
        } else if (!this.state.showFilmStrip && this.state.selectBtn === 2) {
          this.setState({
            openTracksAndAudio: true
          });
        } else if (!this.state.showFilmStrip && this.state.selectBtn === 3) {
          // start play button
          this.playFromStart();
        } else if (!this.state.showFilmStrip && locationState.videoType === "series" && this.state.selectBtn === 4) {
          // episodes button
          this.openEpisodeList();
        }
      }
    } else if (event.keyCode === 38) {
      this.showControls();
      // up button
      if (
        this.state.isPlaying === false ||
        this.isAdUIShown === true ||
        this.state.showEpisodesLists ||
        this.state.openTracksAndAudio ||
        this.state.showFilmStrip ||
        this.state.skipIntroPlay
      )
        return;
      if (this.state.showPlayerControls === true && this.state.selectBtn === 0) {
        if (!this.state.selectFocusBtnAdRemoved && this.isAdRemoved) {
          this.setState({
            selectBtn: 0,
            selectFocusBtnAdRemoved: true
          });
        } else {
          this.setState({
            selectBtn: 1,
            selectFocusBtnAdRemoved: false,
            margin: i18n.getDirection() === "ltr" ? 2 : 1
          });
        }
      }
    } else if (event.keyCode === 40) {
      this.showControls();
      // down button
      if (
        this.state.showEpisodesLists ||
        this.state.openTracksAndAudio ||
        this.isAdUIShown === true ||
        this.state.showFilmStrip ||
        this.state.skipIntroPlay
      )
        return;
      if (this.state.selectBtn > 0) {
        if (!this.state.selectFocusBtnAdRemoved && this.isAdRemoved) {
          this.setState({
            selectBtn: 0,
            selectFocusBtnAdRemoved: true
          });
        } else if (!this.state.selectFocusBtnAdRemoved && !this.isAdRemoved && !locationState.isLive) {
          this.setState({
            selectBtn: 0,
            selectFocusBtnAdRemoved: false
          });
        }
      } else if (!locationState.isLive) {
        this.setState({
          selectBtn: 0,
          selectFocusBtnAdRemoved: false,
          margin: i18n.getDirection() === "ltr" ? 2 : 1
        });
      }
    } else if (event.keyCode === 415) {
      // play button on remote
      if (this.isAdUIShown === true) return;
      if (!this.state.isSeeked && this.state.isPlaying === false) {
        this.setState({
          isPlaying: true,
          selectBtn: 0,
          showFilmStrip: false,
          openTracksAndAudio: false,
          showEpisodesLists: false
        });
        // Adtech Project - Clear Pause Ad States - Start
        if (this.state.pauseAd) {
          this.setState({
            pauseAd: null
          });
        }
        // Adtech Project - Clear Pause Ad States - End
        this.player.play();
        clearInterval(this.showPauseScreenInterval);
        this.setState({
          showPauseScreen: false
        });
        this.showControls();
      } else if (this.state.isSeeked) {
        this.player.pause();

        if (this.isForcedAd) {
          let startTime = this.adBreaksStartTimes[this.isForcedAdIndex];
          this.storedSeekedTime = this.state.seekedTime;
          this.adBreaksIndexes = this.adBreaksIndexes.filter(number => number !== this.isForcedAdIndex);
          this.player.seek(startTime - STUFFSKIPAD);
        } else {
          this.player.seek(this.state.seekedTime);
        }
      }
    } else if (event.keyCode === 19) {
      //pause button on remote
      if (this.isAdUIShown === true) return;
      if (!this.state.isSeeked && this.state.isPlaying === true) {
        // Adtech Project - Setting Pause Ad States - Start
        const pauseAd = await this.getFullScreenAd();
        if (pauseAd) {
          this.setState({
            pauseAd
          });
        }
        // Adtech Project - Setting Pause Ad States - End
        this.setState({
          isPlaying: false,
          selectBtn: 0,
          showFilmStrip: false,
          openTracksAndAudio: false,
          showEpisodesLists: false
        });
        !isLive && this.player.pause();
        // Adtech Project - Setting Focus and Send Impressions - Start
        if (this.state.pauseAd) {
          this.props.setFocus(PAUSE_AD_FOCUS);
          changeState.call(this, playerUiStates.PAUSE);
          const { impressionTrackingURL } = this.state.pauseAd;
          await impressionTracking(impressionTrackingURL);
        }
        // Adtech Project - Setting Focus and Send Impressions - End
        this.showPauseScreenInterval = setInterval(() => {
          this.setState({
            showPauseScreen: true
          });
        }, this.timeToShowPauseScreen);
      }
    }
  }
  handleRemoteKeysFilmstrip(event) {
    const { isLive } = locationState;
    const stopNavOnFocusPath = [LOGIN_MODEL_FOCUS, SIGNUP_MODEL_FOCUS, CANCEL_MODEL_FOCUS, CONTINUE_MODEL_FOCUS];
    const isBlocked = () =>
      this.state.pauseAd ||
      this.state.playerBuffering ||
      this.state.nextEpisodePlay ||
      this.state.skipOutroPlay ||
      this.isAdUIShown ||
      this.shouldShowLoading() ||
      this.showVideoCommerceUI ||
      stopNavOnFocusPath.includes(this.props.applicationState.currentFocus);

    if (isBlocked()) return;
    this.state.showFilmStrip && !locationState.isLive && this.player.pause();
    if (event.keyCode === 37) {
      //left button
      this.showControls();
      this.dismissClicked = false;
      if (this.state.showEpisodesLists || this.state.openTracksAndAudio || this.state.skipIntroPlay) return;
      if (this.appFlow === "ltr" && !this.state.showFilmStrip && this.state.selectBtn > 1) {
        this.setState({
          selectBtn: this.state.selectBtn - 1,
          margin: this.state.margin - 4.5
        });
      } else if (
        this.appFlow === "rtl" &&
        !this.state.showFilmStrip &&
        this.state.selectBtn > 0 &&
        this.state.selectFocusBtnAdRemoved === false &&
        this.state.selectBtn < this.state.totalBtns
      ) {
        this.setState({
          selectBtn: this.state.selectBtn + 1,
          margin: this.state.margin + 4.5
        });
      } else if (this.state.selectBtn === 0 && this.state.selectFocusBtnAdRemoved === false) {
        !isLive && this.seekLeft();
      }
    } else if (event.keyCode === 39) {
      // right button
      this.showControls();
      this.dismissClicked = false;
      if (this.state.showEpisodesLists || this.state.openTracksAndAudio || this.state.skipIntroPlay) return;

      if (
        this.appFlow === "ltr" &&
        !this.state.showFilmStrip &&
        this.state.selectBtn > 0 &&
        this.state.selectFocusBtnAdRemoved === false &&
        this.state.selectBtn < this.state.totalBtns
      ) {
        this.setState({
          selectBtn: this.state.selectBtn + 1,
          margin: this.state.margin + 4.5
        });
      } else if (this.appFlow === "rtl" && !this.state.showFilmStrip && this.state.selectBtn > 1) {
        this.setState({
          selectBtn: this.state.selectBtn - 1,
          margin: this.state.margin - 4.5
        });
      } else if (this.state.selectBtn === 0 && this.state.selectFocusBtnAdRemoved === false) {
        !isLive && this.seekRight();
      }
    }
    if (event.keyCode === 412) {
      //rewind button on remote
      this.state.selectBtn === 0 && this.seekLeft();
    } else if (event.keyCode === 417) {
      //forward button on remote
      this.state.selectBtn === 0 && this.seekRight();
    }
  }

  onVisibilityChange = () => {};
  // getting internal bitmovin audio track
  loadAudioTracks() {
    const newState = {};
    const availableAudioTrack = this.player.getAvailableAudio();
    if (!this.state.audioTracks) {
      newState.audioTracks = extendTrackInfo(
        sdk.playerManager.getAvailableAudioTracks(availableAudioTrack),
        normalizeLang(this.props.applicationState.preferredLanguage.playback.audio),
        true
      );
    }
    this.setState(newState);
    this.props.stateActions.hideGlobalModal();
  }

  /**
   * Gets the information for the subtitles menu and selects the selected subtitle in the menu
   */
  loadSubtitlesTracks() {
    const newState = {};
    const availableTextTracks = this.player.subtitles.list();
    if (!this.state.subtitleTracks) {
      newState.subtitleTracks = extendTrackInfo(
        sdk.playerManager.getAvailableSubtitleTracks(availableTextTracks),
        normalizeLang(this.props.applicationState.preferredLanguage.playback.subtitles),
        true
      );
    }
    this.setState(newState);
  }

  updateSubtitleContainerDirection = language => {
    if (language === "ar" || language === "ur") {
      const element = document.querySelector(".bmpui-container-wrapper");
      element.setAttribute("dir", "rtl");
      element.classList.add("sans-serif-font-family");
    } else {
      const element = document.querySelector(".bmpui-container-wrapper");
      element.setAttribute("dir", "ltr");
      element.classList.remove("sans-serif-font-family");
    }
  };

  /**
   * Selects audio and subtitle track
   * @param {Object} selectedTrack
   */
  selectTrack(selectedTrack) {
    const preferredLanguage = this.props.applicationState.preferredLanguage;
    if (selectedTrack.type === "TEXT") {
      let playerTracks = this.player.subtitles.list();
      if (!playerTracks.some(track => track.lang === "off" && track.kind === "subtitle")) {
        playerTracks.push({ kind: "subtitle", lang: "off" });
      }
      let selectedSubtitle = null;
      if (selectedTrack.index >= 0) {
        try {
          this.player.subtitles.disable(this.state.currentSubtitleID);
        } catch (e) {}
        for (let i = 0; i < playerTracks.length; i++) {
          selectedSubtitle = playerTracks[i];
          if (normalizeLang(selectedTrack.lang) === normalizeLang(selectedSubtitle.lang)) {
            this.player.subtitles.enable(selectedSubtitle.id);
            this.setState({
              currentSubtitleID: selectedSubtitle.id,
              subtitleTracks: updateTracksState(this.state.subtitleTracks, selectedTrack)
            });
            sdk.playerManager.updatePreferences({ subtitles: normalizeLang(selectedTrack.lang) });
            if (preferredLanguage?.playback) preferredLanguage.playback.subtitles = normalizeLang(selectedTrack.lang);
            break;
          }
        }
        this.updateSubtitleContainerDirection(selectedTrack.lang);
      } else {
        this.player.subtitles.disable(this.state.currentSubtitleID);
        this.setState({
          subtitleTracks: updateTracksState(this.state.subtitleTracks, selectedTrack)
        });
        sdk.playerManager.updatePreferences({ subtitles: normalizeLang(selectedTrack.lang) });
        if (preferredLanguage?.playback) preferredLanguage.playback.subtitles = normalizeLang(selectedTrack.lang);
      }
    } else if (selectedTrack.type === "AUDIO") {
      const availableAudioTrack = this.player.getAvailableAudio();
      this.player.setAudio(availableAudioTrack[selectedTrack.index].id);
      sdk.playerManager.updatePreferences({ audio: normalizeLang(selectedTrack.lang) });
      if (preferredLanguage?.playback) preferredLanguage.playback.audio = normalizeLang(selectedTrack.lang);
      this.setState({
        audioTracks: updateTracksState(this.state.audioTracks, selectedTrack)
      });
    }
  }

  isAdexists() {
    const isSVODUser = getAppState()?.isSvodUser;
    const isShowAds = !isSVODUser ? true : locationState?.enforceAds && isSVODUser ? true : false;
    if (
      this.config.adsCountryRights &&
      this.config.adsCountryRights.indexOf(this.adCountry) > -1 &&
      this.config.dash_widevine_ads &&
      locationState?.isEnableVideoCommerce !== "true" &&
      isShowAds
    ) {
      return true;
    } else {
      return false;
    }
  }

  async setupPlayer() {
    if (locationState.videoType === "series" && locationState.playFrom === "cw_home") {
      this.setState({
        totalBtns: 4
      });
    }
    const streamingUrl = locationState.manifest;
    await sdk.playerManager.setup(locationState);
    let self = this;
    const playerConfig = {
      key: "9c89f7d3-2fe7-4986-aaaf-dacaf8f37b93",
      playback: {
        autoplay: false,
        muted: false,
        preferredTech: [
          {
            player: "html5",
            streaming: "dash"
          }
        ]
      },
      ui: false, // disable the built-in UI
      adaptation: {
        desktop: {
          preload: true
        }
      },
      tweaks: {
        file_protocol: true,
        app_id: "d5y9d1orz6.starz",
        MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL: 10,
        XHR_TIMEOUT: 120, // Timeout in seconds
        PROACTIVE_GAP_SKIP_DISTANCE_SECONDS: 0.1,
        dash_clear_buffers_on_period_switches: true,
        max_mpd_retries: 15,
        max_cdn_retries: 15,
        max_retries: 15
      },
      buffer: {
        video: {
          forwardduration: 32,
          backwardduration: 10
        },
        audio: {
          forwardduration: 32,
          backwardduration: 10
        }
      },
      network: {
        preprocessHttpResponse(type, response) {
          if (response && response.headers && response.headers["x-request-id"]) {
            self.xRequestId = response.headers["x-request-id"];
          }
          return response;
        }
      }
    };

    if (this.isAdexists()) {
      const urls = this.config.dash_widevine_ads.streamingUrl
        ? this.config.dash_widevine_ads?.streamingUrl?.split("?")
        : this.config.dash_widevine_ads?.url?.split("?");
      if (urls) {
        try {
          this.requestAdUrl = urls[0];
          const adUrls = urls[1]?.split("&");
          const manifestHost = adUrls[0]?.split("=");
          const trackingHost = adUrls[1]?.split("=");
          this.manifestHostUrl = manifestHost[1];
          this.trackingHostUrl = trackingHost[1];
          let nonce = await this.generateNonce(this.requestAdUrl);
          let duration = this.config.playbackAnalytics.duration || 0;
          let name = this.config.playbackAnalytics.mediaGuid
            ? this.config.playbackAnalytics.mediaGuid
            : this.config.guid;

          const params = await this.getExtraParms();
          let requestUrlresponse = await requestAdPostCall(this.requestAdUrl, nonce, duration, name, params);
          if (!requestUrlresponse) {
            this.isPlayFromAds = false;
            this.loadSource(playerConfig, streamingUrl);
          } else {
            // AVOD non DRM protected check
            if (locationState.dPlay === DPLAY.token && locationState.isEnableNoDrm) {
              await this.getNonDrmToken(this.manifestHostUrl);
              this.manifestHostUrl = `${decodeURIComponent(
                this.manifestHostUrl + requestUrlresponse.manifestUrl
              )}&${parseQueryString(playbackTokenNonDRM.manifestParams)}`;
            } else {
              this.manifestHostUrl = decodeURIComponent(this.manifestHostUrl + requestUrlresponse.manifestUrl);
            }
            this.trackingHostUrl = decodeURIComponent(this.trackingHostUrl + requestUrlresponse.trackingUrl);
            this.isPlayFromAds = true;
            Object.assign(this.config, {
              manifest: this.manifestHostUrl
            });
            this.loadSource(playerConfig, this.manifestHostUrl);
          }
        } catch (e) {
          this.isPlayFromAds = false;
          this.loadSource(playerConfig, streamingUrl);
        }
      } else {
        this.isPlayFromAds = false;
        this.loadSource(playerConfig, streamingUrl);
      }
    } else {
      this.isPlayFromAds = false;
      // non AVOD non DRM Protected Check
      if (locationState.dPlay === DPLAY.token && locationState.isEnableNoDrm) {
        await this.getNonDrmToken(streamingUrl);
        let tokanizeURL = `${streamingUrl}?${parseQueryString(playbackTokenNonDRM.manifestParams)}`;
        this.loadSource(playerConfig, tokanizeURL);
      } else {
        this.loadSource(playerConfig, streamingUrl);
      }
    }
  }

  generateNonce() {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 256; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  async getExtraParms() {
    const deviceName = await getDeviceName();
    const osVersion = await extractHisenseVersion();
    return {
      app_name: "STARZPLAY",
      contentOwnership: locationState.contentOwnership,
      genre: locationState.genre,
      content_language: locationState.content_language,
      content_rating: locationState.content_rating,
      device_make: deviceName,
      device_model: locationState.device_model,
      os_version: osVersion,
      entitlements: getAddonsListWithBase()
    };
  }

  loadPreferredSubtitletracks() {
    let selectedSubtitle = null;
    for (let i = 0; i < this.player.subtitles.list().length; i++) {
      selectedSubtitle = this.player.subtitles.list()[i];
      if (
        normalizeLang(this.props.applicationState.preferredLanguage.playback.subtitles) ===
        normalizeLang(selectedSubtitle.lang)
      ) {
        this.player.subtitles.enable(selectedSubtitle.id);
        this.setState({
          currentSubtitleID: selectedSubtitle.id
        });
        this.updateSubtitleContainerDirection(normalizeLang(selectedSubtitle.lang));
        break;
      }
    }
  }
  //TODO : Audio Language user Prefered is updated
  loadPreferredAudiotracks() {
    const availableAudioTrack = this.player.getAvailableAudio();
    let matchedTrack = null;
    for (let i = 0; i < availableAudioTrack.length; i++) {
      if (
        normalizeLang(this.props.applicationState.preferredLanguage.playback.audio) ===
        normalizeLang(availableAudioTrack[i].lang)
      ) {
        this.player.setAudio(availableAudioTrack[i].id);
        matchedTrack = availableAudioTrack[i].id;
        break;
      }
    }
    if (!matchedTrack) {
      this.player.setAudio(availableAudioTrack[availableAudioTrack.length - 1].id);
    }
  }

  adBreaksCalculation() {
    const { totalTimeInSeconds } = this.state;
    const self = this;
    this.totalTimeInSeconds = this.state.totalTimeInSeconds === 0 ? this.player.getDuration() : totalTimeInSeconds;

    this.adBreaksStartTimes.map(value => {
      const adMarginInPercentage = (value / self.totalTimeInSeconds) * 100;
      this.adMargin.push(Number(adMarginInPercentage.toFixed(1)));
    });
  }

  async extractVideoCommerceData() {
    this.videoCommerceData = await getVideoCommerceData(locationState.mediaGuid);
    if (this.videoCommerceData) {
      Object.keys(this.videoCommerceData).map(frameTime => this.adBreaksStartTimes.push(timeToSeconds(frameTime)));
      Object.keys(this.videoCommerceData).map(frameTime => this.videoCommerceTimes.push(frameTime));
      this.adBreaksCalculation();
    }
  }

  async checkAndCallAdTracker() {
    this.filterAdData = [];
    this.adBreaksStartTimes = [];
    this.adBreaksEndTimes = [];
    const response = await requestAdGetCall(this.trackingHostUrl);

    this.filterAdData = await parseTrackerCallData(response);
    const self = this;
    this.adSeekTime = 0;
    clearInterval(this.adTimeInterval);
    this.isPlayBackStart = true;
    this.adDuration = "00:00";
    this.filterAdData.map(function(breaks, index) {
      self.adBreaksStartTimes.push(parseFloat(breaks.adBreakStartTime.toFixed(2)));
      self.adBreaksEndTimes.push(parseFloat((breaks.adBreakStartTime + breaks.totalAdBreakDuration).toFixed(2)));
      self.totalSkipOutroTimeAdjusmentInSeconds = parseFloat(
        (self.totalSkipOutroTimeAdjusmentInSeconds + breaks.totalAdBreakDuration).toFixed(2)
      );
    });

    this.adBreaksIndexes = this.adBreaksStartTimes.map((_, index) => index);

    const lastAdTimeStarts = this.adBreaksStartTimes[this.adBreaksStartTimes.length - 1];
    if (locationState.credits && locationState.credits.outroStartSeconds !== undefined) {
      if (lastAdTimeStarts >= locationState.credits.outroStartSeconds) {
        this.totalSkipOutroTimeAdjusmentInSeconds -= this.filterAdData[
          this.filterAdData.length - 1
        ].totalAdBreakDuration;
      }
    }
    this.adBreaksCalculation();

    if (
      !this.state.isPlayFromEpisodes &&
      this.filterAdData.length !== 0 &&
      (locationState.playFrom === "cw_home" || locationState.playFrom === "cw_my_library") &&
      this.isPlayfromStartCW === false
    ) {
      await this.seekOnAdCW();
    } else if (this.config.playbackTime !== 0 && this.filterAdData.length !== 0 && this.isPlayfromStartCW === false) {
      if (locationState.whichCTA === EPISODEFOCUS || locationState.whichCTA === PLAY_FROM_RESUME) {
        await this.seekOnAdCW();
      }
    }
  }

  async adUIHandlerOnTimeChange() {
    let self = this;
    if (!locationState.isLive) {
      this.totalAdsInAdBreak = this.filterAdData[
        this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter
      ].totalAds;
      let startTime = parseFloat(
        this.adBreaksStartTimes[
          this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter
        ].toFixed(2)
      );
      let endTime = parseFloat(
        this.adBreaksEndTimes[
          this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter
        ].toFixed(2)
      );
      let currentTime = parseFloat(this.player.getCurrentTime().toFixed(2));
      let ads = this.filterAdData[
        this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter
      ].ads;
      if (currentTime >= startTime && currentTime < endTime) {
        this.isAdUIShown = true;
        this.isAdbreakFinish = true;

        if (this.adCounter < this.totalAdsInAdBreak) {
          if (!this.adTimeInterval) {
            // remove timer for already existed
            if (this.skipDisableTimer !== null) {
              clearTimeout(this.skipDisableTimer);
              this.isSkipBtnDisabled = true;
            }

            this.currentAdData = ads[this.adCounter];
            this.adDurationSetTimeInterval = ads[this.adCounter].adDuration;
            this.adDurationinSeconds = ads[this.adCounter].adDuration;
            this.isSkipable = isValidTime(ads[self.adCounter].skipOffset);
            if (this.isSkipable) {
              this.skipOffset = parseInt(ads[this.adCounter].skipOffset.split(":")[2]);
            }

            this.adRoutingURL = ads[this.adCounter].clickThroughUrls ? ads[this.adCounter].clickThroughUrls[0] : "";
            if (!this.hasDefaultAdUIFocus) {
              this.hasDefaultAdUIFocus = true;
              this.adRoutingURL
                ? this.props.setFocus(SEND_TO_PHONE)
                : !this.adRoutingURL && this.isSkipBtnDisabled && this.props.setFocus(defaultFocusPath);
            }
            if (this.skipOffset !== null && this.isSkipable) {
              this.skipDisableTimer = setTimeout(() => {
                this.isSkipBtnDisabled = false;
                !this.adRoutingURL && this.props.setFocus(SKIP_AD);
              }, this.skipOffset * 1000);
            }
            this.adTimeInterval = setInterval(function() {
              // smooth progress Bar set to 100MS
              if (self.isAdStalled === false) {
                self.adSeekTime += 0.1;
                self.adDurationSetTimeInterval -= 0.1;
                self.adDurationSetTimeInterval =
                  self.adDurationSetTimeInterval < 0 ? 0 : self.adDurationSetTimeInterval;
                self.isSkipable = isValidTime(ads[self.adCounter].skipOffset);
                if (self.isSkipable) {
                  self.skipOffset = parseInt(ads[self.adCounter].skipOffset.split(":")[2]);
                }

                self.adDuration = self.toMinutesAndSeconds(self.adDurationSetTimeInterval);
                if (self.adDurationSetTimeInterval <= 0) {
                  self.adSeekTime = 0;
                  self.currentAdData = null;
                  self.isAdStarted = true;
                  self.adCounter++;
                  clearInterval(self.adTimeInterval);
                  self.adTimeInterval = null;
                }
              }
            }, 100);
          }
          if (currentTime === parseInt(self.currentAdData.adStartTime) && self.isAdStarted) {
            self.isAdStarted = false;
          }
        } else {
          // for Ad
          this.adDuration = "00:00";
          if (this.adBreaksStartTimes.length === 1) {
            this.adCounter = 0;
          }
          this.isPlayBackStart = false;
          // this.adDurationinSeconds = 0;
          this.adDurationSetTimeInterval = 0;
          clearInterval(this.adTimeInterval);
          this.adTimeInterval = null;
          this.isSkipBtnDisabled = true;
          clearTimeout(this.skipDisableTimer);
        }
      } else {
        // for Ad break
        this.isAdUIShown = false;
        if (
          currentTime >= endTime &&
          (this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter) <
            this.adBreaksEndTimes.length
        ) {
          if (this.isAdbreakFinish === true) {
            if (this.isForcedAd) {
              this.player.seek(this.storedSeekedTime);
              if (this.isForcedAdFomCW) {
                this.adBreakCounter = await this.getNextAdIndexCW(this.storedSeekedTime, this.adBreaksStartTimes);
              } else {
                this.adBreaksIndexes = this.adBreaksIndexes.filter(number => number !== this.isForcedAdIndex);
                this.adBreakCounter = this.isForcedAdIndex + 1;
              }
              this.isForcedAd = false;
              this.isForcedAdFomCW = false;
              this.isPlayfromStartCW = false;
              if (this.adBreakCounter === this.adBreaksEndTimes.length) {
                this.adBreakCounter = this.adBreaksEndTimes.length - 1;
              }
            } else {
              this.adBreaksIndexes = this.adBreaksIndexes.filter(number => number !== this.adBreakCounter);
              this.adBreakCounter++;
              if (this.adBreakCounter === this.adBreaksEndTimes.length) {
                this.adBreakCounter = this.adBreaksEndTimes.length - 1;
              }
            }
            this.resetAdbreak();
            setTimeout(async () => {
              // this is beacuse during ad playback no audio and subtitle internal is extracting
              // as they are inside only in content stream not in ad
              if (!self.hasLoadedTracks) {
                //once
                await self.loadTracksAndCaptions();
                self.hasLoadedTracks = true;
              }
            }, 1000);
          }
        }
      }
    } else {
      // if live content only preroll ads
      this.totalAdsInAdBreak = this.filterAdData[0].totalAds;
      let ads = this.filterAdData[0].ads;
      if (this.isPlayBackStart && this.adCounter < this.totalAdsInAdBreak) {
        this.isAdUIShown = true;
        if (!this.adTimeInterval) {
          this.currentAdData = ads[this.adCounter];
          this.adDurationSetTimeInterval = ads[this.adCounter].adDuration;
          this.adDurationinSeconds = ads[this.adCounter].adDuration;
          this.adRoutingURL = ads[this.adCounter].clickThroughUrls ? ads[this.adCounter].clickThroughUrls[0] : "";
          if (!this.hasDefaultAdUIFocus) {
            this.hasDefaultAdUIFocus = true;
            !this.showQRCodeModal && this.adRoutingURL && this.props.setFocus(SEND_TO_PHONE);
          }
          this.adTimeInterval = setInterval(function() {
            // smooth progress Bar set to 100MS
            if (self.isAdStalled === false) {
              self.adSeekTime += 0.1;
              self.adDurationSetTimeInterval -= 0.1;
              self.adDurationSetTimeInterval = self.adDurationSetTimeInterval < 0 ? 0 : self.adDurationSetTimeInterval;
              self.adDuration = self.toMinutesAndSeconds(self.adDurationSetTimeInterval);
              if (self.adDurationSetTimeInterval <= 0) {
                self.adSeekTime = 0;
                self.adCounter++;
                self.isAdStarted = true;
                self.currentAdData = null;
                clearInterval(self.adTimeInterval);
                self.adTimeInterval = null;
              }
            }
          }, 100);
        }
        if (self.isAdStarted) {
          self.isAdStarted = false;
        }
      } else {
        setTimeout(function() {
          // this is beacuse during ad playback no audio and subtitle internal is extracting
          // as they are inside only in content stream not in ad
          if (!self.hasLoadedTracks) {
            //once
            self.loadTracksAndCaptions();
            self.hasLoadedTracks = true;
          }
        }, 1000);
        this.adCounter = 0;
        this.isAdUIShown = false;
        this.hasDefaultAdUIFocus = false;
        this.isPlayBackStart = false;
        clearInterval(this.adTimeInterval);
        this.adTimeInterval = null;
        this.isSkipBtnDisabled = true;
        clearTimeout(this.skipDisableTimer);
      }
    }
  }

  videoCommerceUIHandler() {
    const { isLive } = locationState;
    if (!isLive) {
      let startTime = parseFloat(this.adBreaksStartTimes[this.adBreakCounter].toFixed(2));
      this.filteredVCData = this.videoCommerceData[this.videoCommerceTimes[this.adBreakCounter]];
      this.adBreakEndTime =
        (this.filteredVCData.length !== 0 && startTime + this.filteredVCData[0].display_time_seconds) || 0;
      let currentTime = parseFloat(this.player.getCurrentTime().toFixed(2));
      if (currentTime >= startTime && currentTime < this.adBreakEndTime) {
        this.setState({ showPlayerControls: false }, () => {
          this.showVideoCommerceUI = true;
          this.props.setFocus(FOCUS_ON_CARDS);
        });
      } else if (this.showVideoCommerceUI && currentTime >= this.adBreakEndTime) {
        this.showVideoCommerceUI = false;
        this.adBreakEndTime = 0;
        this.filteredVCData = [];
        this.adBreaksStartTimes.length > this.adBreakCounter && this.adBreakCounter++;
        this.showControls();
      }
    }
  }

  async checkConcurrency() {
    const { isAllowPlayback, concurrency } = await getConcurrency.call(this, this.config.addonContent);
    this.isAllowPlayback = isAllowPlayback;
    this.concurrency = concurrency;
  }

  getSumOfAllPackages(packages) {
    let totalSum = 0;
    const addonContent = this.config.addonContent;
    const { subscriptions } = this.props.applicationState;
    const parentAddOnContent = getSuperParentAddOnNameForConcurrency(subscriptions, addonContent);
    let addonContentChildren = [];
    if (parentAddOnContent) {
      addonContentChildren =
        subscriptions?.find(sub => sub.name === parentAddOnContent)?.configuration?.subscriptionIncludes?.split(",") ||
        [];
    } else {
      addonContentChildren = [makeBaseContentAsStarzplay(addonContent)]; // starz has no parent so it will land in else case the we need to convert starz back to starzplay to check the concurrency count for it
    }
    totalSum = packages?.reduce((sum, pkg) => {
      return addonContentChildren.includes(pkg.package) ? sum + pkg.count : sum;
    }, 0);
    return totalSum;
  }

  extractDomainFromManifestUrl(url = "") {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname;
  }

  async getNonDrmToken(url) {
    // Define a retry wrapper that will attempt to fetch the No DRM playback token.
    const fetchNoDRMWithRetry = async (retryCount = 0, maxRetries = 1) => {
      const profile = await getCurrentProfile();
      try {
        const noDRMReqBody = {
          globalUserId: profile?.profileId,
          releasePids: locationState.releasePid || ["noFd3g7vuDHY"],
          protectionScheme: config.get().player.drmTechnology,
          country: getAppState().country,
          hostName: this.extractDomainFromManifestUrl(url),
          HASH_KEY: getSignatureKeyV1()
        };
        playbackTokenNonDRM = await sdk.authenticationManager.getPlaybackTokenNoDRM(noDRMReqBody);
      } catch (e) {
        // Retry for transient errors (not 4xx client errors)
        if (![400, 422, 406, 499].includes(e?.code) && retryCount < maxRetries) {
          return await fetchNoDRMWithRetry(retryCount + 1, maxRetries);
        }

        await this.props.stateActions.setForceLogout(e);
        // if Force logout show the popup
        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
        // Prepare error objects and call existing handler to surface error to player UI
        let httpError = {
          REQUEST: e?.url,
          RESPONSE: e?.code
        };

        let error = {
          code: NODRM_CALL_ERROR_CODE,
          data: { name: e.message }
        };

        // Stop player manager and surface the error
        sdk.playerManager.willStop();
        this.playerErrorHandler(error, null, true, httpError);
        return false;
      }
    };
    await fetchNoDRMWithRetry();
  }

  async loadSource(playerConfig, streamingUrl) {
    const { isLive } = locationState;
    this.player = new Player(document.getElementById("av-player"), playerConfig);
    this.props.stateActions.setPlayer(this.player);
    this.props.stateActions.setPlayerConfig(this.config);
    if (this.config.contentType !== "AVOD") {
      this.checkConcurrency();
      const isConcurrencyFlow = await isInitiateConcurrencyFlow(this.config.addonContent);
      if (isConcurrencyFlow) {
        const userid = isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId");
        sdk.mediaManager.concurrencyCheck(userid).then(concurrencyConfig => {
          this.setState({ totalPackageCount: this.getSumOfAllPackages(concurrencyConfig.packages) });
        });
      }
    }

    // in case of non protected and protected non drm dont send tokens and call LA url
    const isNonTrailor = ["movie", "series"].includes(locationState.videoType);
    if (isNonTrailor && !locationState?.isEnableNoDrm) {
      // Define a retry wrapper that will attempt to fetch the DRM playback token.
      const fetchDRMWithRetry = async (retryCount = 0, maxRetries = 1) => {
        const profile = await getCurrentProfile();
        const DRMReqBody = {
          globalUserId: profile?.profileId,
          releasePids: locationState.releasePid,
          protectionScheme: config.get().player.drmTechnology,
          country: getAppState().country,
          HASH_KEY: getSignatureKeyV1()
        };

        try {
          playbackToken = await sdk.authenticationManager.getPlaybackTokenV3(DRMReqBody);
          return true; // success
        } catch (e) {
          // Retry for transient errors (not 4xx client errors)
          if (![400, 422, 406, 499].includes(e?.code) && retryCount < maxRetries) {
            return await fetchDRMWithRetry(retryCount + 1, maxRetries);
          }

          // If force logout required, propagate
          await this.props.stateActions.setForceLogout(e);
          if (!!getAppState().forceLogout) {
            this.props.resumeNavigation();
            await showForceLogoutError.call(this);
            return false;
          }

          // Prepare error objects and call existing handler to surface error to player UI
          let httpError = {
            REQUEST: e?.url,
            RESPONSE: e?.code,
            SHA256: e?.sha256,
            JSTimeStamp: e?.JSTimeStamp,
            timestamp: e?.timestamp,
            dayJSTimeStamp: e?.dayJSTimeStamp,
            timestampSource: e?.timestampSource
          };

          let error = {
            code: VAULTO_CALL_ERROR_CODE,
            data: { name: e.message }
          };

          // Stop player manager and surface the error
          sdk.playerManager.willStop();
          await this.playerErrorHandler(error, null, true, httpError);
          return false;
        }
      };

      // Invoke the DRM fetch before building the source so playbackToken is available
      const tokenFetched = await fetchDRMWithRetry();
      if (!tokenFetched) {
        return;
      }
    }

    const widevineURL =
      (await getWidevineURL(getAppState().widevineConfig, getAppState().country)) ||
      "https://widevine-license.vudrm.tech/proxy";

    // this is used to replace the current mena urls to https starz play url . need something to remove hardcoded
    streamingUrl = streamingUrl
      .replace(/http\:\/\/mena-jit-cdn-lb.aws.playco.com/, "https://mena-jit-cdn-lb.aws.playco.com")
      .replace(/https?:\/\/starzplay-jit-prod-ssl.akamaized.net/, "https://mena-jit-cdn-lb.aws.playco.com");

    const source = {
      dash: streamingUrl,
      options: {
        startOffset: this.config.playbackTime !== 0 ? this.config.playbackTime : 0
      },
      ...(!locationState?.isEnableNoDrm && {
        // Include DRM only if dPlay is not "free" or "token"
        drm: {
          widevine: {
            LA_URL: widevineURL,
            prepareMessage(keyMessage) {
              return JSON.stringify({
                token: playbackToken,
                drm_info: Array.from(new Uint8Array(keyMessage.message))
              });
            }
          }
        }
      }),
      events: {
        [PlayerEvent.Error]: this.playerErrorEventHandler
      }
    };
    Logger.log("On Init event callback function is going to run. Is mounted:TRUE", "Player.onInit");
    Logger.log("Initializing player load timer", "Player.onInit");
    setPlayerLoadTimer.call(this);
    this.player
      .load(source)
      .then(async () => {
        const subtitleUI = new UIContainer({
          components: [new SubtitleOverlay(), new SeekBar()]
        });

        this.player.on(PlayerEvent.Ready, this.readyEventHandlerTimeout);

        this.player.on(PlayerEvent.Seek, this.seekEventHandler);
        destroyPlayerLoadTimer.call(this);

        // Launch the UI
        const uiManager = new UIManager(this.player, subtitleUI);
        this.player.play();

        //subtitles audio and filmstrip
        if (!isLive) this.getFilmStrip();

        await this.loadTracksAndCaptions();

        // start playing event bitmovin
        // this.con
        this.player.on(PlayerEvent.Playing, this.playEventHandler);

        // playback finished event bitmovin
        this.player.on(PlayerEvent.PlaybackFinished, this.playbackFinishedEventHandler);

        // time update event bitmovin
        this.player.on(PlayerEvent.TimeChanged, this.timeChangedEventHandler);

        // segment playback bitmovin
        this.player.on(PlayerEvent.SegmentPlayback, this.segmentPlaybackEventHandler);
      })
      .catch(e => {
        Logger.log(
          `Requesting error message for error: ${e} after failure in bitmovin player config`,
          "Player.loadSource"
        );
        destroyPlayerLoadTimer.call(this);
      });

    this.player.on(PlayerEvent.Error, this.playerErrorEventHandler);
    this.player.on(PlayerEvent.StallStarted, this.stallStartedEventHandler);
    this.player.on(PlayerEvent.StallEnded, this.stallEndedEventHandler);
    ///////////////// start : Analytics Youbora ///////////////
    const { playbackAnalytics } = config.get().featureToggles;
    !!playbackAnalytics && (await sdk.playerManager.startPlaybackAnalytics(this.config));
    ///////////////// end : Analytics Youbora ///////////////
  }

  async loadTracksAndCaptions() {
    this.resetTracks();
    this.loadSubtitlesTracks();
    this.loadAudioTracks();
    this.loadPreferredSubtitletracks();
    this.loadPreferredAudiotracks();
  }
  /**
   * After turning off the player load timer to avoid doubling errors, checks if any error code is received to get
   * its customized error message to show in a modal and sends an error report.
   * @param {Object} error - Error data
   */

  stallStartedEventHandler = e => {
    this.setState({
      playerBuffering: true
    });
    this.isAdStalled = true;
    this.networkErrorTimeout = setTimeout(() => {
      this.playerErrorEventHandler({
        code: 1400
      });
    }, 10000);
  };
  stallEndedEventHandler = e => {
    this.setState({
      playerBuffering: false
    });
    this.isAdStalled = false;
    this.networkErrorTimeout && clearTimeout(this.networkErrorTimeout);
  };
  playerErrorHandler(error, bitmovinEvent = null, istokenCallFails = false, httpError = null) {
    if (error && error.data) {
      const { sendReport = true } = error;
      try {
        Logger.log(`Player emitted an error ${error.code} with data: ${error.data.name}`, "Player.playerErrorHandler");
        destroyPlayerLoadTimer.call(this, false);
        Logger.log(`Requesting error message for error: ${error && error.code}`, "Player.playerErrorHandler");
        const message = error.code && getPlayerErrorMessage(error.code);
        const messageHeading = error.code && getPlayerErrorMessageHeading(error.code);
        sendReport && sendPlayerErrorReport.call(this, error, message, bitmovinEvent, istokenCallFails, httpError);
        this.didErrorHappen = true;
        // Next state checking is due to double errors that might come from sdk, such as related with DRM.
        !this.state.errorMessage && this.showErrorModal(message, messageHeading);
      } catch (error) {
        Logger.log(`Requesting error message for error: ${error && error.code}`, "Player.playerErrorHandler");
        const message = getPlayerErrorMessage(error.code);
        this.showErrorModal(message);
      }
      // byte+ stay event
      // to prevent duplicate stay call in exit, update state
      this.setState({ stayEventCalledFromPlayerErr: true });
      sendStayEventForBytePlus({
        titleId: locationState?.id,
        seriesId: sessionStorage.getItem("currentlyPlayingid"),
        subType: locationState?.contentType || locationState?.assetTypesPriority,
        mediaData: locationState,
        playerCurrentTime: this.player.getCurrentTime() || this?.state?.currentTimeInSeconds
      });
      sdk.playerManager.destroy();
    } else {
      Logger.log(`Player ignored an error ${error.code} with data: ${error.data.name}`, "Player.playerErrorHandler");
    }
  }

  static getPlayerLog(player) {
    const { playbackState, activePanel, currentTime, playerBuffering, duration, currentTimeInSeconds } = player;

    return {
      playbackState,
      activePanel,
      currentTime,
      playerBuffering,
      duration,
      currentTimeInSeconds
    };
  }

  showErrorModal(message, errorMessageHeading = null) {
    this.props.resumeNavigation();
    this.setState({ errorMessage: message, errorMessageHeading });
    this.errorButtonClose.props.setFocus();
  }

  checkTimeForSendEvent() {
    const { isLive, moduleId, videoType, seriesId } = locationState;
    if (this.state.currentTimeInSeconds !== this.previousSecond) {
      this.calculateTimes();
      const foundPlaybackTime = this.getPlaybackTimePercentIndex(this.state.currentTimeInSeconds);
      if (!isLive && this.playbackTimes.length > 0 && foundPlaybackTime > -1) {
        sendUserEvent({
          module_id: moduleId,
          id: this.config.id,
          action: "watch",
          value: this.playbackPercentages[foundPlaybackTime],
          ...(videoType === "series" && { parent_id: seriesId })
        });
        this.playbackPercentages.splice(0, foundPlaybackTime + 1);
      }
      this.previousSecond = this.state.currentTimeInSeconds;
    }
  }
  checkPercentageTimePlayed(isTrailer = false) {
    // byte+ stay event
    if (!this.state.stayEventCalledFromPlayerErr) {
      if (this?.state?.lastStayEventSentFor != locationState?.id) {
        this.setState({ lastStayEventSentFor: locationState?.id });
        sendStayEventForBytePlus({
          titleId: locationState?.id,
          seriesId: sessionStorage.getItem("currentlyPlayingid"),
          subType: locationState?.contentType || locationState?.assetTypesPriority,
          mediaData: locationState,
          playerCurrentTime: this.player.getCurrentTime()
        });
      }
    }
    if (!isTrailer) {
      const { isLive, moduleId, videoType, seriesId } = locationState;
      videoType !== "trailer" &&
        !isLive &&
        sendUserEvent({
          module_id: moduleId,
          id: this.config.id,
          action: "stop",
          value: this.getPercentPlayed(),
          eventType: "watch",
          ...(videoType === "series" && { parent_id: seriesId })
        });
    }
  }

  /**
   * Returns the percent played with two decimals
   * @returns {Number}
   */
  getPercentPlayed() {
    const percent = this.state.currentTimeInSeconds / this.state.totalTimeInSeconds;
    return percent.toFixed(2);
  }

  updateFocus() {
    const active = this.state.activePanel;
    switch (active) {
      case playerUiStates.NONE:
        this.currentFocus = defaultFocusPath;
        break;
      case playerUiStates.CONTROLS_PLAYING:
      case playerUiStates.CONTROLS_PAUSED:
        this.currentFocus =
          this.lastFocused || (locationState.isLive ? ControlsSettings.defaultFocusPath : Controls.defaultFocusPath);
        this.lastFocused = null;
        break;
      case playerUiStates.PAUSE:
        this.currentFocus = PauseAdScreen.defaultFocusPath;
        break;
      case playerUiStates.TRACKS:
        this.currentFocus = Tracks.defaultFocusPath;
        break;
      case playerUiStates.NEXT_EPISODE:
        this.currentFocus = NextEpisode.defaultFocusPath;
        break;
      case playerUiStates.EPISODE_SELECTOR:
        this.currentFocus = EpisodesSelectorScreen.defaultFocusPath;
        break;
      case playerUiStates.SKIP_INTRO:
        this.currentFocus = SKIP_INTRO_BUTTON_FOCUS_PATH;
        break;
      case playerUiStates.SKIP_OUTRO:
        this.currentFocus = NextEpisode.defaultFocusPath;
        break;
      default:
        this.currentFocus = defaultFocusPath;
        break;
    }
    this.props.setFocus(this.currentFocus);
  }

  calculateTimes() {
    if (this.state.totalTimeInSeconds) {
      this.playbackTimes = this.playbackPercentages.map(percentage => {
        return Math.floor(this.state.totalTimeInSeconds * percentage);
      });
    }
  }

  /**
   * Looks if the current percentage time played is in the percentages array.
   * This array (this.playbackTimes) has the percentages in which the user event will be sent.
   * @param {Number} currentTimeInSeconds
   * @returns {Number} Returns 0 if the index of the percent playing is in array or -1 if not
   */
  getPlaybackTimePercentIndex(currentTimeInSeconds) {
    const playbackTimeIndex = this.playbackTimes.findIndex(item => item > currentTimeInSeconds);

    if (this.playbackTimes.length > 1) {
      return playbackTimeIndex - 1;
    } else if (this.playbackTimes.length === 1) {
      return this.playbackTimes[0] < currentTimeInSeconds ? 0 : -1;
    }
    return -1;
  }

  bindings() {
    this.playEpisode = this.playEpisode.bind(this);
    this.setFocusAfterModalOpen = this.setFocusAfterModalOpen.bind(this);
    this.shouldRenderPlaybackRate = this.shouldRenderPlaybackRate.bind(this);
    this.selectTrack = this.selectTrack.bind(this);
    this.showSkipIntro = this.showSkipIntro.bind(this);
    this.showSkipOutro = this.showSkipOutro.bind(this);
    this.skipIntroAction = this.skipIntroAction.bind(this);
    this.getEpisodesList = this.getEpisodesList.bind(this);
    this.skipOutroAction = throttle(this.skipOutroAction.bind(this), 2000); // 2 sec throttle
    this.openADSponsorAction = this.openADSponsorAction.bind(this);
    this.skipAdAction = throttle(this.skipAdAction.bind(this), 2000); // 2 sec throttle
    this.dismissOutro = this.dismissOutro.bind(this);
    this.back = this.back.bind(this);
    this.getNextEpisode = this.getNextEpisode.bind(this);
    this.handleRemoteKeys = this.handleRemoteKeys.bind(this);
    this.handleRemoteKeysFilmstrip = this.handleRemoteKeysFilmstrip.bind(this);
    this.showProgressBar = this.showProgressBar.bind(this);
    this.showBar = this.showBar.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.getFullScreenAd = this.getFullScreenAd.bind(this);
    this.pauseAdHandler = this.pauseAdHandler.bind(this);
    this.VideoCommerceHandler = this.VideoCommerceHandler.bind(this);
    this.removeAdAction = this.removeAdAction.bind(this);
  }

  onBack() {
    const { history, location } = this.props;
    if (location.state?.from?.name === "/search") {
      history.goBack();
      return true;
    } else if (this.state.showEpisodesLists === true) {
      this.setState({
        showEpisodesLists: false
      });
      this.player.play();
      return true;
    } else if (this.state.openTracksAndAudio === true) {
      this.setState({
        openTracksAndAudio: false
      });
      return true;
    } else if (this.state.showPlayerControls === true) {
      this.setState({
        showPlayerControls: false
      });
      return true;
    } else if (this.showVideoCommerceUI) {
      const { focusedCarouselItemIndex: index } = this.props.applicationState;
      const item = this.filteredVCData[index];
      trackEvent("adtech_vc_close", null, VC, item);
      this.showVideoCommerceUI = false;
      this.adBreakEndTime = 0;
      this.filteredVCData = [];
      this.adBreaksStartTimes.length > this.adBreakCounter && this.adBreakCounter++;
      this.showControls();
      return true;
    } else {
      locationState.videoType !== "trailer" && this.state.totalTimeInSeconds && this.checkPercentageTimePlayed();
      locationState.videoType == "trailer" && this.checkPercentageTimePlayed(true);
      return false;
    }
  }

  /**
   * Shows skip intro
   */
  showSkipIntro() {
    if (config.get().featureToggles.skipIntro) {
      if (this.shouldShowSkipIntro()) {
        this.setState({
          skipIntroPlay: true
        });
        changeState.call(this, playerUiStates.SKIP_INTRO);
      } else if (!this.shouldShowSkipIntro()) {
        this.setState({
          skipIntroPlay: false
        });
        if (
          this.props.applicationState.currentFocus !== "nextEpisode" &&
          this.props.applicationState.currentFocus !== "buttonBackNextEpisode"
        ) {
          changeState.call(this, playerUiStates.NONE);
        }
      }
    }
  }

  /**
   * Returns true if the skip intro have to be shown. Otherwise returns false
   * @returns {Boolean}
   */
  shouldShowSkipIntro() {
    try {
      const { introStartSeconds, introEndSeconds } = locationState.credits;
      if (introEndSeconds) {
        return (
          this.state.seekedTime >= parseInt(introStartSeconds + (parseInt(this.adBreaksEndTimes[0]) || 0)) &&
          this.state.seekedTime <= parseInt(introEndSeconds + (parseInt(this.adBreaksEndTimes[0]) || 0))
        );
      }
    } catch (e) {}
    return false;
  }

  /**
   * Returns true if the skip outro have to be shown. Otherwise returns false
   * @returns {Boolean}
   */
  shouldShowSkipOutro() {
    if (locationState.credits) {
      const { outroStartSeconds, outroEndSeconds } = locationState.credits;
      const { seekedTime, totalTimeInSeconds } = this.state;
      const startCalculate = outroStartSeconds + this.totalSkipOutroTimeAdjusmentInSeconds;
      const endCalculate = outroEndSeconds + this.totalSkipOutroTimeAdjusmentInSeconds;
      const updatedOutroStartTime = parseFloat(startCalculate.toFixed(2));
      const updatedOutroEndTime = parseFloat(endCalculate.toFixed(2));
      const lastAdTimeStarts = this.adBreaksStartTimes[this.adBreaksStartTimes.length - 1] || 0;

      if (updatedOutroStartTime) {
        const outroCheck =
          totalTimeInSeconds > updatedOutroStartTime &&
          seekedTime >= updatedOutroStartTime &&
          seekedTime < updatedOutroEndTime &&
          this.dismissOutroInterval === null;

        const isOnlyPreloadAd = updatedOutroStartTime < lastAdTimeStarts && updatedOutroEndTime < lastAdTimeStarts;

        return lastAdTimeStarts > 0 && updatedOutroStartTime < lastAdTimeStarts
          ? outroCheck && isOnlyPreloadAd
          : outroCheck;
      }
    }
    return false;
  }

  /**
   * Shows skip outro
   */
  async showSkipOutro() {
    if (config.get().featureToggles.skipOutro) {
      let episodeData = await this.getNextEpisode(true);
      if (typeof episodeData === "undefined") return;
      if (this.shouldShowSkipOutro()) {
        if (!this.isNextEpisodeRequested) {
          this.isNextEpisodeRequested = true;
          this.setState({
            skipOutroPlay: true,
            showPlayerControls: false,
            openTracksAndAudio: false,
            nextEpisode: episodeData
          });

          if (this.state.nextEpisode) {
            changeState.call(this, playerUiStates.SKIP_OUTRO);
            if (this.dismissClicked) {
              clearInterval(this.dismissOutroInterval);
              this.dismissOutroInterval = null;
            } else {
              this.dismissOutroInterval = setInterval(() => this.skipOutroNextEpisode(), 1000);
              this.dismissClicked = false;
            }
          }
        }
      }
    }
  }

  /**
   * Removes the skip outro screen
   */
  async dismissOutro() {
    this.dismissClicked = true;
    clearInterval(this.dismissOutroInterval);
    this.dismissOutroInterval = null;
    const outroTimmer = await this.checkOutroTime();
    this.setState({
      skipOutroPlay: false,
      skipOutroCountDown: outroTimmer
    });
  }

  getPlayerTimerValue(timerName, defaultValue) {
    const playertimers = getAppState().playertimers;
    const timerValue = playertimers && playertimers[timerName];

    if (
      !Number.isInteger(timerValue) ||
      timerValue === 0 ||
      timerValue === "" ||
      timerValue === null ||
      timerValue === undefined
    ) {
      return defaultValue;
    }
    return timerValue;
  }

  checkOutroTime() {
    const defaultOutroClock = config.get().player.skipOutroCountDown;
    return this.getPlayerTimerValue("outro", defaultOutroClock);
  }

  checkNextEpTime() {
    const defaultNextClock = config.get().player.nextEpisodeCountDown;
    return this.getPlayerTimerValue("next", defaultNextClock);
  }

  startNextEpisodeCountDown(nextEpisode) {
    this.setState({
      nextEpisodeCountDown: this.checkNextEpTime()
    });
    this.nextEpisodeTimer = setInterval(() => {
      if (this.state.nextEpisodeCountDown <= 1) {
        this.playEpisode(nextEpisode, true);
        changeState.call(this, playerUiStates.NONE);
        this.clearNextEpisodeCountDown();
        return;
      }
      this.setState({
        nextEpisodeCountDown: this.state.nextEpisodeCountDown - 1
      });
    }, 1000);
  }

  clearNextEpisodeCountDown() {
    clearInterval(this.nextEpisodeTimer);
  }

  /**
   * Manages the skip outro countdown
   */
  skipOutroNextEpisode() {
    this.setState({
      skipOutroCountDown: this.state.skipOutroCountDown - 1
    });
    if (this.state.skipOutroCountDown < 1 && locationState.videoType === "series") {
      this.skipOutroAction();
    }
  }

  /**
   * Go to the player position in which the intro ends
   */
  skipIntroAction() {
    this.player.pause();
    this.player.seek(
      parseInt(locationState.credits.introEndSeconds + (parseInt(this.adBreaksEndTimes[0]) || 0) + STUFFSKIPADONLAST)
    );
  }

  /**
   * Callback for the skip outro poster
   */
  async skipOutroAction() {
    clearInterval(this.dismissOutroInterval);
    this.dismissOutroInterval = null;
    this.setState({
      skipOutroPlay: false
    });
    await this.playEpisode(this.state.nextEpisode, true);
  }

  /**
   * Callback for the skip ad if enabled
   */
  skipAdAction() {
    this.player.pause();
    const skipPadding = this.adCounter === this.totalAdsInAdBreak - 1 ? STUFFSKIPADONLAST : 0;
    const timeUpdated = this.state.seekedTime + this.adDurationSetTimeInterval;
    if (this.adCounter === this.totalAdsInAdBreak - 1) {
      this.isAdUIShown = false;
    }

    if (this.adBreakCounter === this.adBreaksStartTimes.length - 1) {
      // check for last ad break
      if (this.adCounter === this.totalAdsInAdBreak - 1) {
        // check if last ad of last adbreak
        this.player.seek(parseFloat(timeUpdated.toFixed(2)) + skipPadding);
      } else {
        this.player.seek(parseFloat(timeUpdated.toFixed(2)) + skipPadding);
      }
    } else {
      // any other ad break
      this.player.seek(parseFloat(timeUpdated.toFixed(2)) + skipPadding);
    }

    this.isAdStalled = true;
    this.isAdSkipped = true;
  }

  async getNextEpisode(isFromOutro) {
    // FIXME: revisit episodes retrieval flow because this might delay too much the appearance of next episode screen.
    this.retryCount = 0;
    if (
      locationState.seriesId &&
      (!this.state.episodesList ||
        (this.state.episodesList && !this.state.episodesList.length) ||
        !locationState.episodesList ||
        (locationState.episodesList && !locationState.episodesList.length))
    ) {
      this.setState({ episodeSelectorLoading: !this.shouldShowSkipOutro() }); // If we're requesting next episode data from the skip outro we haven't to show loading
      const seriesData = await getSeasonsAndEpisodesList(locationState.seriesId);
      this.setState({ episodeSelectorLoading: false, ...seriesData });
    }
    if (!isFromOutro) this.isAdUIShown = false;

    const episodesList = this.getEpisodesList();
    const index = episodesList.findIndex(
      title =>
        this.state.tvSeasonEpisodeNumber === title.tvSeasonEpisodeNumber &&
        this.state.tvSeasonNumber === title.tvSeasonNumber
    );
    if (episodesList[index + 1]) {
      episodesList[index + 1].progress && (episodesList[index + 1].progress["playbackTime"] = 0);
    }
    nextEpisodeData = episodesList[index + 1];
    return episodesList[index + 1];
  }

  async playNextEpisode() {
    let nextEpisode;
    // byte+ stay event
    if (this?.state?.lastStayEventSentFor != locationState?.id) {
      this.setState({ lastStayEventSentFor: locationState?.id });
      sendStayEventForBytePlus({
        titleId: locationState?.id,
        seriesId: sessionStorage.getItem("currentlyPlayingid"),
        subType: locationState?.contentType || locationState?.assetTypesPriority,
        mediaData: locationState,
        playerCurrentTime: this.player.getCurrentTime()
      });
    }
    this.player.unload();
    this.retryCount = 0;
    this.setState({
      nextEpisodePlay: true
    });
    if (!this.state.nextEpisode) {
      nextEpisode = await this.getNextEpisode(false);
    }

    !!nextEpisode && this.setState({ nextEpisode });
    try {
      if (this.state.nextEpisode) {
        changeState.call(this, playerUiStates.NEXT_EPISODE);
        if (!this.state.isFreePlaybackEnded) this.startNextEpisodeCountDown(this.state.nextEpisode);
        else this.props.setFocus("globalModalContinueFocusPath_passThru");
      } else {
        this.setState({
          nextEpisodePlay: false
        });
        this.back();
      }
    } catch (e) {
      this.setState({
        nextEpisodePlay: false
      });
      this.back();
    }
  }

  setFocusAfterModalOpen(focusPath) {
    const { setFocus } = this.props;
    setTimeout(() => {
      this.props.resumeNavigation();
    }, 1);
    setFocus(focusPath);
  }

  /**
   * Plays new episode, from next episode or episode selector
   * @param {Object} episode Object with the info of the new episode
   * @param {Boolean} isNextEpisodeCountdownFinished Indicates if the countdown for go to the next episode has finished
   */
  async playEpisode(episode, isNextEpisodeCountdownFinished = false) {
    // byte+ stay event
    if (this?.state?.lastStayEventSentFor != locationState?.id) {
      this.setState({ lastStayEventSentFor: locationState?.id });
      sendStayEventForBytePlus({
        titleId: locationState?.id,
        seriesId: sessionStorage.getItem("currentlyPlayingid"),
        subType: locationState?.contentType || locationState?.assetTypesPriority,
        mediaData: locationState,
        playerCurrentTime: this.player.getCurrentTime()
      });
    }
    // byte+ youbora screen pass
    var bytePlusYouboraData = await getYouboraParamsForBytePlus({
      titleId:
        locationState?.videoType === "movie" || locationState?.videoType === "trailer"
          ? locationState?.id
          : locationState?.seriesId
    });
    this.config = { ...this.config, ...bytePlusYouboraData };
    const { isActiveUser } = this.props.applicationState;

    const isThisSeriesHasFreeEpisodes = JSON.parse(localStorage.getItem("isThisSeriesHasFreeEpisodes"));
    episode.tags = episode.tags || [];
    if (isThisSeriesHasFreeEpisodes && !isActiveUser && !isFVODFreeToAir(episode.tags)) {
      const { location } = this.props.history;
      localStorage.setItem("playerReferrer", location.referrer);
      this.setState({ isFreePlaybackEnded: true });
      this.props.setFocus("globalModalContinueFocusPath_passThru");
      showSubscriptionModal.call(
        this,
        episode.addonContent,
        true,
        null,
        location.referrer,
        isChampionsTrophyAddOn(episode.addonContent)
      );
      return;
    }
    // If episode selected is the same as the one being played, it will exit episode selector and resume playback.
    this.resetAdsPlayer();
    this.adBreaksStartTimes = [];
    this.adMargin = [];
    this.retryCount = 0;
    const outroTimmer = await this.checkOutroTime();
    this.setState({
      playerBuffering: true,
      nextEpisodePlay: false,
      skipOutroCountDown: outroTimmer
    });

    this.clearUserMediaCached();
    this.dismissClicked = false;
    this.isNextEpisodeRequested = false;
    const titleFor4K = this.is4KSessionSelectedQuality() && !!episode["4kProgramId"];
    const has4K = titleFor4K && this.props.applicationState.supports4K;
    const media = episode.mediaContent[0];
    locationState.filmstrip = media.content.filmstrip || null;
    const playbackTime = (episode.progress && episode.progress.playbackTime) || 0;
    const countryRightsData = await this.getAdsCountryRightsData(episode.tvSeasonNumber, episode.tvSeasonEpisodeNumber);
    const noDrmConfig = episode?.config || null;
    const streamingData = getStreamingURL(countryRightsData, episode?.ecommerceAds, noDrmConfig, media?.content.video);
    sdk.playerManager.setCurrentTime(playbackTime);
    const newConfig = {
      videoType: "series",
      contentTypeYoubora: getContentTypeForAnalytics(episode),
      manifest: streamingData?.streamingUrl || media.content.video.streamingUrl,
      releasePid: streamingData?.releasePid || media.content.video.releasePid,
      releaseUrl: streamingData?.releaseUrl || media.content.video.releaseUrl,
      duration: streamingData?.duration || media.content.video.duration,
      playbackTime,
      id: episode.id,
      has4K,
      dash_widevine_ads: streamingData || null,

      dPlay: noDrmConfig?.dPlay || null,
      isEnableNoDrm: isEnableNoDrm(countryRightsData, noDrmConfig, media?.content.video) || false,
      adsCountryRights: countryRightsData,
      assetType: this.isPlayFromAds ? WIDEVINE_FORMATS.withAd : WIDEVINE_FORMATS.withoutAd,
      contentType: locationState.contentType,
      contentOwnership: locationState.contentOwnership,
      profileType: locationState.profileType,
      userid: isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId"),

      externalSubtitles: media.content.subtitles,
      seasonNumber: episode.tvSeasonNumber,
      episodeNumber: episode.tvSeasonEpisodeNumber,
      tvSeasonEpisodeNumber: episode.tvSeasonEpisodeNumber,
      tvSeasonNumber: episode.tvSeasonNumber,
      ...(config.get().featureToggles.skipIntro &&
        locationState.videoType === "series" && {
          credits: media.credits
        }),
      playbackAnalytics: {
        newEpisode: true,
        title: this.state.seriesTitle,
        season: episode.tvSeasonNumber || 0,
        episode: episode.tvSeasonEpisodeNumber || 0,
        mediaGuid: media.mediaGuid,
        duration: streamingData?.duration || media.content.video.duration,
        genre: locationState.genre,
        is4KEnabled: this.is4KSessionSelectedQuality() && has4K,
        playFrom:
          (this.state.activePanel === playerUiStates.NEXT_EPISODE && PLAY_FROM_NEXT_EPISODE) ||
          (this.state.activePanel === playerUiStates.EPISODE_SELECTOR && PLAY_FROM_EPISODE_SELECTOR),
        resume: !!playbackTime
      },
      isEnableVideoCommerce: episode?.ecommerceAds || false,
      enforceAds: noDrmConfig?.enforceAds || false
    };
    this.playbackPercentages = [...config.get().player.playbackPercentages];

    const newState = {
      title: episode.title,
      description: episode.shortDescription,
      episodeLabel: getEpisodeLabel(episode.tvSeasonNumber, episode.tvSeasonEpisodeNumber),
      tvSeasonNumber: episode.tvSeasonNumber,
      tvSeasonEpisodeNumber: episode.tvSeasonEpisodeNumber,
      episodeSelectorLoading: false,
      player: null,
      isPlaying: true,
      isSeeked: false,
      seekedTime: 0,
      duration: "00:00",
      currentTime: "00:00",
      currentTimeInSeconds: 0,
      totalTimeInSeconds: 0,
      nextEpisodePlay: false,
      skipIntroPlay: false,
      skipOutroPlay: false,
      isPlayFromStart: false,
      playbackRate: 0,
      margin: i18n.getDirection() === "ltr" ? 2 : 1,
      selectBtn: 0,
      totalBtns: 4,
      textLabels: [
        "",
        i18n.get("global.back"),
        i18n.get("pages.player.settings.audioSubtitles"),
        i18n.get("global.playFromBeginning"),
        i18n.get("global.media.episodes")
      ],
      playerBuffering: true,
      openTracksAndAudio: false,
      showFilmStrip: false,
      subtitleTracks: null,
      showPauseScreen: false,
      showPlayerControls: true,
      isPlayFromEpisodes: true,
      audioTracks: null,
      filmstripData: null,
      nextEpisode: null,
      currentSubtitleID: null,
      showEpisodesLists: false
    };
    this.filmstrip = null;
    this.playbackIconName = "";
    Object.assign(locationState, newConfig);
    // Byte+ GA event for play click
    sendVideoPlayClickEventDataForBytePlus({
      thisInstance: this,
      mediaData: episode,
      currentScreen: sessionStorage?.getItem("currScreen2"),
      previousScreen: sessionStorage?.getItem("prevScreen2")
    });
    this.player.unload();
    await this.updateConfig();
    Logger.log(locationState.manifest, "Manifest");
    this.setState(newState, async () => {
      this.setupPlayer();
    });
  }

  seasonChanged(seasonIndex) {
    if (!locationState.tvImpressionWatchedList) {
      locationState.tvImpressionWatchedList = [];
    }
    if (!locationState.tvImpressionWatchedList.includes(seasonIndex)) {
      let epList = locationState?.episodesList || this?.state?.episodesList || this?.episodesList;
      let firstIndexOfSeasonEp = epList?.findIndex(item => item.tvSeasonNumber === seasonIndex + 1);
      let lastIndexOfSeasonEp = epList?.findIndex(item => item.tvSeasonNumber === seasonIndex + 2);
      let episodesToSend = [];
      if (lastIndexOfSeasonEp != -1) {
        for (let i = firstIndexOfSeasonEp; i < lastIndexOfSeasonEp; i++) {
          episodesToSend.push(epList[i]);
        }
        locationState.tvImpressionWatchedList = [...locationState.tvImpressionWatchedList, seasonIndex];
        sendTrueViewImpressionForBytePlus({
          carouselContents: episodesToSend || null,
          currentScreen: sessionStorage?.getItem("currScreen2"),
          previousScreen: sessionStorage?.getItem("prevScreen2")
        });
      } else {
        for (let i = firstIndexOfSeasonEp; i < epList.length; i++) {
          episodesToSend.push(epList[i]);
        }
        locationState.tvImpressionWatchedList = [...locationState.tvImpressionWatchedList, seasonIndex];
        sendTrueViewImpressionForBytePlus({
          carouselContents: episodesToSend || null,
          currentScreen: sessionStorage?.getItem("currScreen2"),
          previousScreen: sessionStorage?.getItem("prevScreen2")
        });
      }
    }
  }

  clearUserMediaCached() {
    this.props.applicationState.userMediaCached = null;
  }

  is4KSessionSelectedQuality() {
    return (
      sessionStorage &&
      JSON.parse(
        sessionStorage.getItem("seriesPlaying4K") !== "undefined" ? sessionStorage.getItem("seriesPlaying4K") : false
      )
    );
  }

  async togglePausePlay() {
    const isSVODUser = getAppState()?.isSvodUser;
    const isShowAds = !isSVODUser ? true : locationState?.enforceAds && isSVODUser ? true : false;
    if (!locationState.isLive) {
      this.dismissClicked = false;
      if (!this.state.isSeeked) {
        if (this.state.isPlaying === false) {
          this.setState({
            isPlaying: true,
            selectBtn: 0,
            selectFocusBtnAdRemoved: false,
            showFilmStrip: false,
            openTracksAndAudio: false,
            showEpisodesLists: false
          });
          isShowAds && (await this.addTeckApiCallPlusStateUpdate(true));
          this.player.play();
          clearInterval(this.showPauseScreenInterval);
          this.setState({
            showPauseScreen: false
          });
          this.showControls();
        } else {
          isShowAds && (await this.addTeckApiCallPlusStateUpdate());
          this.setState({
            isPlaying: false,
            selectBtn: 0,
            selectFocusBtnAdRemoved: false,
            showFilmStrip: false,
            openTracksAndAudio: false,
            showEpisodesLists: false
          });
          this.player.pause();
          getAppState().playbackPausedTime = new Date().getTime();
          sdk.playerManager.pause();
          // Disable Video Commerce UI
          if (this.showVideoCommerceUI) {
            this.showVideoCommerceUI = false;
            this.adBreaksStartTimes.length > this.adBreakCounter && this.adBreakCounter++;
          }
          // Adtech Project - Setting Focus and Send Impressions - Start
          if (this.state.pauseAd) {
            this.props.setFocus(PAUSE_AD_FOCUS);
            changeState.call(this, playerUiStates.PAUSE);
            const { impressionTrackingURL } = this.state.pauseAd;
            await impressionTracking(impressionTrackingURL);
          }
          // Adtech Project - Setting Focus and Send Impressions - End
          this.showPauseScreenInterval = setInterval(() => {
            this.setState({
              showPauseScreen: true
            });
          }, this.timeToShowPauseScreen);
          this.showControls();
        }
      } else {
        const playState = this.state.isPlaying;
        const self = this;
        playState ? this.player.pause() : this.player.play();
        this.setState({ isPlaying: !playState });

        if (this.state.showFilmStrip) {
          this.player.pause();
          const isLandOnAdbreak = await this.findTimeIndex(
            this.state.seekedTime,
            this.adBreaksStartTimes,
            this.adBreaksEndTimes
          );
          if (this.isForcedAd) {
            isLandOnAdbreak !== -1 ? (this.isForcedAd = false) : (this.isForcedAd = true);
            this.storedSeekedTime = this.state.seekedTime;
          }

          this.player.seek(isLandOnAdbreak !== -1 ? this.adBreaksEndTimes[isLandOnAdbreak] : this.state.seekedTime);
          if (this.isForcedAd) {
            setTimeout(function() {
              let startTime = self.adBreaksStartTimes[self.isForcedAdIndex];
              self.player.seek(startTime - STUFFSKIPAD);
            }, DELAY_TIMEOUT);
          }
        }
      }
    }
  }

  async addTeckApiCallPlusStateUpdate(clearPauseAdState = false) {
    if (clearPauseAdState) {
      if (this.state.pauseAd) {
        this.setState({
          pauseAd: null
        });
      }
      return;
    }
    const pauseAd = await this.getFullScreenAd();
    if (pauseAd) {
      this.setState({
        pauseAd
      });
    }
  }

  // Adtech Project - Getting Full Screen Ad - Start
  async getFullScreenAd() {
    const { id, videoType, playFrom, title, seriesTitle, assetTypes, genres } = locationState;
    const { showPauseAds } = this.props.applicationState;
    const isSeriesTitle = videoType === "series" && playFrom !== "cw_my_library" ? true : false;
    let pauseAd = null;

    if (showPauseAds) {
      this.setState({ playerBuffering: true });
      pauseAd = await getPauseAd({
        id,
        title: isSeriesTitle ? seriesTitle : title,
        assetTypes,
        genres,
        ...(locationState.isEnableVideoCommerce === "true" && { ecommerceAds: true })
      });
    }
    this.setState({ playerBuffering: false });
    return pauseAd;
  }
  // Adtech Project - Getting Full Screen Ad - End

  pausedSeek() {
    this.setState({
      isPlaying: false
    });
    this.player.pause();
    getAppState().playbackPausedTime = new Date().getTime();
    sdk.playerManager.pause();
  }

  seekLeft() {
    //10 seconds back
    this.playbackIconName = "rewind";
    if (this.state.isPlaying === true) {
      this.pausedSeek();
    }
    if (this.state.seekedTime > 0) {
      this.setState({
        showFilmStrip: true,
        seekedTime: this.state.seekedTime - 10,
        isSeeked: true
      });
      this.filterAdData.length !== 0 && this.adSeeker(false);
      if (this.videoCommerceData) {
        this.adBreakCounter = this.getNextAdIndex(this.state.seekedTime, this.adBreaksStartTimes) || 0;
      }
      // time should updated in view instant when seek left is pressed
      let time = this.toMinutesAndSeconds(this.state.seekedTime);
      if (this.isNextEpisodeRequested) {
        this.dismissClicked = false;
        this.isNextEpisodeRequested = false;
      }
      this.setState({
        currentTime: time
      });

      if (!this.state.filmstripData) {
        // this.getFilmStrip();
      } else {
        onStateEnter[playerUiStates.FILMSTRIP].call(this);
      }
    }
  }
  seekRight(defaultSeekTime = 10) {
    this.playbackIconName = "forward";
    // 10 seconds forward
    if (this.state.isPlaying === true) {
      this.pausedSeek();
    }
    if (this.state.seekedTime + defaultSeekTime <= this.player.getDuration() - defaultSeekTime) {
      this.setState({
        showFilmStrip: true,
        seekedTime: this.state.seekedTime + defaultSeekTime,
        isSeeked: true
      });

      this.filterAdData.length !== 0 && this.adSeeker(true);
      if (this.videoCommerceData) {
        this.adBreakCounter = this.getNextAdIndex(this.state.seekedTime, this.adBreaksStartTimes) || 0;
      }
      // time should updated in view instant when seek right is pressed
      let time = this.toMinutesAndSeconds(this.state.seekedTime);
      this.setState({
        currentTime: time
      });

      if (!this.state.filmstripData) {
        // this.getFilmStrip();
      } else {
        onStateEnter[playerUiStates.FILMSTRIP].call(this);
      }
    }
  }

  async getAdBreakIndex(seekedTime, starts, ends) {
    for (let i = 0; i < starts.length; i++) {
      if (seekedTime >= starts[0] && seekedTime <= starts[1]) {
        return 0;
      } else if (seekedTime >= starts[i] && seekedTime <= ends[i]) {
        return i;
      }
    }
    return -1;
  }

  async findTimeIndex(currentTime, startTimes, endTimes) {
    for (let i = 0; i < startTimes.length; i++) {
      if (currentTime >= startTimes[i] && currentTime <= endTimes[i]) {
        return i;
      }
    }
    return -1;
  }

  async isCurrentAndSeekTimeAtSameInterval(startTimeArray, currentTime, seekTime) {
    let currentTimeInterval = null;
    let seekTimeInterval = null;
    let areIntervalsSame = false;

    // Check if currentTime or seekTime is greater than the last time in the array
    const lastTime = startTimeArray[startTimeArray.length - 1];
    if (currentTime > lastTime) {
      currentTimeInterval = [lastTime, Infinity]; // Use Infinity to indicate "beyond the last interval"
    }
    if (seekTime > lastTime) {
      seekTimeInterval = [lastTime, Infinity]; // Same for seekTime
    }

    for (let i = 0; i < startTimeArray.length - 1; i++) {
      if (currentTime > startTimeArray[i] && currentTime < startTimeArray[i + 1]) {
        currentTimeInterval = [startTimeArray[i], startTimeArray[i + 1]];
      }
      if (seekTime > startTimeArray[i] && seekTime < startTimeArray[i + 1]) {
        seekTimeInterval = [startTimeArray[i], startTimeArray[i + 1]];
      }
    }

    // If both intervals have been found, compare them
    if (currentTimeInterval && seekTimeInterval) {
      areIntervalsSame =
        currentTimeInterval[0] === seekTimeInterval[0] && currentTimeInterval[1] === seekTimeInterval[1];
    }

    return areIntervalsSame;
  }

  async getNextAdIndexCW(seekTime, startTimes) {
    let lowerIndex = -1;
    let upperIndex = -1;
    for (let i = 0; i < startTimes.length - 1; i++) {
      const current = startTimes[i];
      const next = startTimes[i + 1];

      if ((seekTime > current && seekTime < next) || (seekTime < current && seekTime > next)) {
        lowerIndex = i;
        upperIndex = i + 1;
        break; // Exit loop once we find the pair
      }
    }
    return seekTime > startTimes[startTimes.length - 1] ? startTimes.length - 1 : upperIndex;
  }

  getNextAdIndex(seekTime, startTimes) {
    let index = 0;
    for (let i = 0; i < startTimes.length - 1; i++) {
      const current = startTimes[i];
      const next = startTimes[i + 1];
      const currentEndTime = this.adBreakEndTime ? this.adBreakEndTime : current + 60;

      if (seekTime > currentEndTime && seekTime < next) {
        index = i + 1;
        break;
      } else if (seekTime > current && seekTime < next) {
        index = i;
        break;
      }
    }
    return seekTime > startTimes[startTimes.length - 1] ? startTimes.length - 1 : index;
  }

  async adSeeker(isNotRewind) {
    if (this.isAdexists() || this.videoCommerceData) {
      let seekedTime = this.state.seekedTime;
      const isSameInterval = await this.isCurrentAndSeekTimeAtSameInterval(
        this.adBreaksStartTimes,
        this.player.getCurrentTime(),
        seekedTime
      );
      if (!isSameInterval) {
        if (isNotRewind) {
          const adBreakIndex = await this.getAdBreakIndex(seekedTime, this.adBreaksStartTimes, this.adBreaksEndTimes);
          if (adBreakIndex !== -1) {
            const isAdBreakNumberExits = this.adBreaksIndexes.includes(adBreakIndex);
            if (isAdBreakNumberExits) {
              this.isForcedAdIndex = adBreakIndex;
              localStorage.setItem("adbreakexitindex", adBreakIndex);
              this.isForcedAd = true;
            } else {
              this.adBreakCounter = await this.getNextAdIndexCW(seekedTime, this.adBreaksStartTimes);
              if (this.adBreakCounter === -1) this.adBreakCounter = 0;
              this.isForcedAd = false;
            }
          }
        } else if (!isNotRewind) {
          this.adBreakCounter = await this.getNextAdIndexCW(seekedTime, this.adBreaksStartTimes);
          if (this.adBreakCounter === -1) this.adBreakCounter = 0;
          this.isForcedAd = false;
        }
      } else if (isSameInterval) {
        const isAdBreakNumberExits = this.adBreaksIndexes.includes(parseInt(localStorage.getItem("adbreakexitindex")));
        localStorage.removeItem("adbreakexitindex");
        if (isAdBreakNumberExits) {
          this.isForcedAd = true;
        }
      }
    }
  }

  async reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }
  async seekOnAdCW() {
    await this.reloadWait(1000); // delay 1 sec
    let seekedTime = this.player.getCurrentTime(); //this.state.seekedTime;
    const isLandOnAdbreak = await this.findTimeIndex(
      locationState.playFrom === "cw_home" ? this.config.playbackTime : seekedTime,
      this.adBreaksStartTimes,
      this.adBreaksEndTimes
    );
    if (isLandOnAdbreak !== -1) {
      seekedTime = this.adBreaksEndTimes[isLandOnAdbreak];
    }
    const findNextAdIndex = await this.getNextAdIndexCW(
      locationState.playFrom === "cw_home" ? this.config.playbackTime : seekedTime,
      this.adBreaksStartTimes
    );
    this.storedSeekedTime =
      locationState.playFrom === "cw_home"
        ? isLandOnAdbreak !== -1
          ? seekedTime
          : this.config.playbackTime
        : seekedTime;
    this.isForcedAdIndex = findNextAdIndex;
    this.isForcedAdFomCW = true;
    this.isForcedAd = true;
    this.adBreaksIndexes = this.adBreaksIndexes.filter(number => number !== 0); // remove 0th pre roll ad from list
    this.player.seek(0);
  }

  playerErrorEventHandler = event => {
    let errorCode = getErrorCode(event.code);
    let error = {
      code: errorCode,
      data: {
        name: event.name
      }
    };

    if (errorCode === DISCONNECTIVIITY_INTERNET_ERROR_CODE) {
      this.player.pause();
    }

    this.playerErrorHandler(error, event);
  };

  skipIntroActionSeekedEventHandler = event => {
    this.setState({
      isSeeked: false,
      skipIntroPlay: false
    });
    this.player.play();
  };

  skipAdActionSeekedEventHandler = event => {
    this.adSeekTime = 0;
    this.adCounter++;
    this.setState({
      isSeeked: false
    });
    clearInterval(this.adTimeInterval);
    this.adTimeInterval = null;

    this.adRoutingURL
      ? this.props.setFocus(SEND_TO_PHONE)
      : this.isAdRemoved
      ? this.props.setFocus(REMOVE_AD_BUTTON)
      : this.props.setFocus(defaultFocusPath);
    this.player.play();
  };

  playFromStartSeekedEventHandler = event => {
    this.setState({
      currentTime: "00:00",
      isSeeked: false,
      isPlayFromStart: false
    });
    this.player.play();
    sdk.playerManager.seek();
    this.resetAdsPlayer();
  };

  readyEventHandlerTimeout = async () => {
    const { isLive } = locationState;
    const isSVODUser = getAppState()?.isSvodUser;
    const isShowAds = !isSVODUser ? true : locationState?.enforceAds && isSVODUser ? true : false;
    sdk.playerManager.ready();
    this.clearNextEpisodeCountDown();
    Logger.log("Tizen Bitmovin player Ready", "Player.Ready");
    this.setState(
      {
        currentTime: this.toMinutesAndSeconds(this.config.playbackTime !== 0 ? this.config.playbackTime : 0)
      },
      this.setState({
        isPlayerLoaded: true,
        playbackState: "init"
      })
    );
    if (this.isAdexists() && (!Array.isArray(this.filterAdData) || !this.filterAdData.length)) {
      await this.checkAndCallAdTracker();
    }
    if (isShowAds && locationState?.isEnableVideoCommerce === "true") {
      await this.extractVideoCommerceData();
    }
    await setHeartBeatTimer(locationState.contentType);
    sdk.playerManager.stop(false);
    sdk.playerManager.configSuccess(this.config);
  };

  seekEventHandler = e => {
    sdk.playerManager.setCurrentTime(e.seekTarget * 1000);
    clearInterval(this.showPauseScreenInterval);
    clearTimeout(this.showHidePlayerControls);

    sdk.playerManager.seek();
    this.setState({
      seekedTime: e.seekTarget,
      currentTime: this.toMinutesAndSeconds(e.seekTarget)
    });

    this.player.on(PlayerEvent.Seeked, this.seekedHandler);

    this.setState({ playerBuffering: true }, () => {
      this.player.pause();
    });
  };

  seekedHandler = e => {
    if (this.isAdSkipped) {
      this.skipAdActionSeekedEventHandler();
      this.isAdSkipped = false;
      return;
    }

    if (this.state.isPlayFromStart) {
      this.playFromStartSeekedEventHandler();
      return;
    }
    if (this.state.skipIntroPlay) {
      this.skipIntroActionSeekedEventHandler();
      return;
    }

    const playState = this.state.isPlaying;
    if (playState) {
      if (this.videoCommerceData) {
        this.adBreakCounter = this.getNextAdIndex(this.state.seekedTime, this.adBreaksStartTimes);
      }
      getAppState().playbackPausedTime = null;
      sdk.playerManager.play();
      this.setState({ playerBuffering: false, isSeeked: false, showFilmStrip: false }, () => {
        this.player.play();
      });
    } else {
      getAppState().playbackPausedTime = new Date().getTime();
      sdk.playerManager.pause();
      this.setState({ playerBuffering: false, isSeeked: false, showFilmStrip: false }, () => {
        this.player.pause();
      });
    }
  };

  playEventHandler = event => {
    let time = this.toMinutesAndSeconds(this.player.getDuration());
    !this.showVideoCommerceUI && !this.showQRCodeModal && this.showControls();
    Logger.log("this.mounted value is:true", "Player.onPlay");
    let resumeFrom = this.config.playbackTime !== 0 ? this.config.playbackTime : 0;
    if (resumeFrom !== 0 && this.state.isTryToplayFromResume === true) {
      // Important : do not Assign this.adBreakCounter to 0 if the below condition is false .
      // because this is used to tell player which adbreak is upcomming
      if (this.videoCommerceData) {
        this.adBreakCounter = this.getNextAdIndex(resumeFrom, this.adBreaksStartTimes);
      }
      this.setState({
        currentTime: this.toMinutesAndSeconds(resumeFrom)
      });
    }
    this.isAdStalled = false;
    this.setState({
      duration: time,
      playerBuffering: false,
      playbackState: "play",
      nextEpisodePlay: false,
      totalTimeInSeconds: this.player.getDuration()
    });
    getAppState().playbackStartTime = new Date().getTime();
    getAppState().playbackPausedTime = null;
    getAppState().playbackStartSeconds = this.config.playbackTime;
    sdk.playerManager.play();
  };

  segmentPlaybackEventHandler = data => {};

  timeChangedEventHandler = event => {
    // concurrency error check
    if (
      this.state.totalPackageCount >= this.concurrency &&
      !this.isAllowPlayback &&
      this.config.contentType !== "AVOD"
    ) {
      let error = {
        code: "571140",
        data: {
          name: "concurrency"
        }
      };
      this.player.pause();
      this.player.unload();
      this.playerErrorHandler(error);
    }
    this.setState({
      seekedTime: this.player.getCurrentTime()
    });
    let time = this.toMinutesAndSeconds(this.player.getCurrentTime());
    this.setState({
      currentTime: time,
      currentTimeInSeconds: this.player.getCurrentTime()
    });
    // send current time in milliseconds for heartbeat
    if (!this.state.showFilmStrip) {
      sdk.playerManager.setCurrentTime(this.player.getCurrentTime() * 1000);
    }
    locationState.videoType !== "trailer" && this.state.totalTimeInSeconds && this.checkTimeForSendEvent();
    if (locationState.videoType === "series") {
      this.showSkipIntro();
      this.showSkipOutro();
    }
    if (this.isAdexists() && this.filterAdData.length !== 0) {
      this.adUIHandlerOnTimeChange();
    }
    if (this.videoCommerceData) {
      this.subtitlesUIAdjust();
      const resumeFrom = this.config.playbackTime !== 0 ? this.config.playbackTime : 0;
      if (resumeFrom !== 0 && this.state.isTryToplayFromResume) {
        this.adBreakCounter = this.getNextAdIndex(resumeFrom, this.adBreaksStartTimes);
        this.setState({
          isTryToplayFromResume: false
        });
      }
      let startTime = parseFloat(this.adBreaksStartTimes[this.adBreakCounter].toFixed(2));
      if (this.state.currentTimeInSeconds.toFixed(2) >= startTime) {
        this.videoCommerceUIHandler();
      }
    }
  };

  playEventSeekedEventHandler = event => {
    this.player.play();
    this.setState({
      isTryToplayFromResume: false
    });
  };

  playbackFinishedEventHandler = event => {
    if (locationState.videoType !== "series") {
      this.backHandler();
    } else if (locationState.videoType === "series") {
      if (this.isAdexists() && this.filterAdData.length !== 0) {
        if (this.adBreakCounter === this.adBreaksStartTimes.length - 1) {
          if (this.isAdbreakFinish === true) {
            this.isAdUIShown = false;
            clearInterval(this.dismissOutroInterval);
            this.dismissOutroInterval = null;
            this.resetAdbreak();
          }
        }
      }
      this.playNextEpisode();
    }
  };

  playFromStart() {
    this.player.pause();
    this.setState(
      {
        seekedTime: 0,
        isPlayFromStart: true
      },
      () => this.player.seek(this.state.seekedTime)
    );
    this.isPlayfromStartCW = true;
    if (this.isNextEpisodeRequested) {
      this.dismissClicked = false;
      this.isNextEpisodeRequested = false;
    }
  }

  getCurrentTimestamp() {
    return this.state.seekedTime * 1000 || 0;
  }

  shouldShowLoading() {
    return this.state.playerBuffering;
  }

  getSeasonsList() {
    const { seasonsList } = this.state;
    return (
      (locationState.seasonsList && locationState.seasonsList.length && locationState.seasonsList) ||
      (seasonsList && seasonsList.length && seasonsList)
    );
  }

  getEpisodesList() {
    const { episodesList } = this.state;
    return (
      (locationState.episodesList && locationState.episodesList.length && locationState.episodesList) ||
      (episodesList && episodesList.length && episodesList) ||
      []
    );
  }

  getFilmStrip() {
    locationState !== "trailer" &&
      sdk.mediaManager
        .getFilmstripData(locationState.filmstrip)
        .then(filmstripData => this.setState({ filmstripData }));
  }

  toMinutesAndSeconds(elapsedTime) {
    let hours = Math.trunc(elapsedTime / 60 / 60);
    elapsedTime -= hours * 60 * 60;
    let minutes = Math.trunc(elapsedTime / 60);
    let seconds = Math.trunc(elapsedTime % 60);
    if (seconds < 0) seconds = 0;
    if (hours === 0) {
      hours = "";
    } else if (hours < 10) {
      hours = `0${hours}:`;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return `${hours}${minutes}:${seconds}`;
  }

  shouldRenderPlaybackRate() {
    return this.state.showFilmStrip && (this.state.playbackRate > 0 || !this.hasThumbnails());
  }

  hasThumbnails() {
    return (
      this.state.filmstripData && this.state.filmstripData.thumbnails && !!this.state.filmstripData.thumbnails.length
    );
  }

  destroyPlayer() {
    if (this.player != null) {
      this.player.destroy();
      this.setState({
        ...this.state,
        player: null
      });
    }
  }
  scrollUpDown(event) {
    this.wheelState = "active";
    if (event.deltaY > 0) {
      // down wheel moves
      this.props.applicationState.currentFocus === SEASONFOCUS && this.props.setFocus(EPISODEFOCUS);
    } else if (event.deltaY < 0) {
      // up wheel moves
      this.props.applicationState.currentFocus === EPISODEFOCUS && this.props.setFocus(SEASONFOCUS);
    }
  }

  closeModal(focusPath = defaultFocusPath) {
    if (!this.state.pauseAd) {
      this.player.play();
      this.isAdStalled = false;
    }
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus(focusPath);
    this.showQRCodeModal = false;
  }

  openADSponsorAction() {
    this.player.pause();
    this.isAdStalled = true;
    this.showQRCodeModal = true;
    return showQRCodeModal.call(this, this.closeModal.bind(this), this.adRoutingURL);
  }
  // Adtech Project - Pause Ad Button Action - Start
  pauseAdHandler() {
    const { pauseAd } = this.state;
    const titleURL = this.state.pauseAd?.destURL;
    const qrCodeURL = this.state.pauseAd?.clickTrackingURL;
    const isShowPauseAd = pauseAd ? true : false;
    return showQRCodeModal.call(this, this.closeModal.bind(this), titleURL, qrCodeURL, isShowPauseAd);
  }
  // Adtech Project - Pause Ad Button Action - End

  VideoCommerceHandler(index) {
    const item = this.filteredVCData[index];
    const data = {
      title: item.title,
      link: item.link,
      currentPrice: `${item?.currency || ""} ${item?.final_price || ""} `,
      originalPrice: ""
    };
    this.player.pause();
    this.showQRCodeModal = true;
    trackEvent("adtech_vc_click", null, VC, item);
    return showVideoCommerceModal.call(this, this.closeModal.bind(this), data);
  }

  async removeAdAction() {
    const {
      history: { location },
      applicationState: { userLogged, addons }
    } = this.props;
    const { pauseAd } = this.state;
    const currentProfile = await getCurrentProfile();
    this.showQRCodeModal = pauseAd ? false : true;
    this.isRemoveAdPopupOpen = pauseAd ? false : true;
    this.player.pause();
    if (userLogged) {
      const kidsProfileEnabled = currentProfile?.profileCategory === "KIDS" ? true : false;
      if (kidsProfileEnabled) {
        const subscriptionName = getBrandsName(addons, locationState?.addonContent);
        return showContentNotAccessibleModal.call(
          this,
          this.closeModal.bind(this, pauseAd ? REMOVE_AD_PAUSE_BUTTON_FOCUS_PATH : REMOVE_AD_BUTTON),
          {
            isSVODContent: true,
            name: subscriptionName?.displayName
          }
        );
      } else {
        return showSubscriptionModal.call(
          this,
          locationState.addonContent,
          true,
          null,
          location.referrer,
          isChampionsTrophyAddOn(locationState.addonContent)
        );
      }
    } else {
      return showNotLoggedModal.call(
        this,
        { backPageReference: this.props.location.referrer, nextPageReference: this.props.location.referrer },
        this.closeModal.bind(this, pauseAd ? REMOVE_AD_PAUSE_BUTTON_FOCUS_PATH : REMOVE_AD_BUTTON)
      );
    }
  }

  render() {
    const { videoType, isLive, backgroundCover } = locationState;
    const { isActiveUser } = this.props.applicationState;

    return !!this.state.errorMessage ? (
      <Modal
        headingText={this.state.errorMessageHeading || ""}
        mainText={this.state.errorMessage}
        headerIcon={<FreeLogo />}
      >
        <ButtonFocus
          label={i18n.get("global.close").toUpperCase()}
          focusPath="errorBackButton"
          onEnterPress={this.state.isMaxDeviceReached === true ? this.maxDeviceBack.bind(this) : this.back}
          onMouseUp={this.state.isMaxDeviceReached === true ? this.maxDeviceBack.bind(this) : this.back}
          onRef={ref => (this.errorButtonClose = ref)}
          size="small"
          displayBlock={true}
          spacing="xsmall"
        />
      </Modal>
    ) : (
      <Wrapper onClick={this.showProgressBar.bind(this)}>
        {this.shouldShowLoading() && (
          <>
            {this.state.showEpisodesLists && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  zIndex: 10
                }}
              />
            )}
            <Loading overlay />
          </>
        )}
        {videoType !== "trailer" &&
        !this.state.playerBuffering &&
        !this.state.showEpisodesLists &&
        !this.state.isSeeked &&
        this.isAdUIShown === false &&
        this.state.isPlaying === false ? (
          !this.shouldShowLoading() && this.state.pauseAd ? (
            <PauseAdScreen
              focusPath={PAUSE_AD_FOCUS}
              adImage={this.state.pauseAd?.imageURL}
              title={
                this.state.seriesTitle
                  ? i18n.get("global.adTech.pauseAd.resumeCta", this.state.seriesTitle)
                  : this.state.title && i18n.get("global.adTech.pauseAd.resumeCta", this.state.title)
              }
              thumbnail={backgroundCover}
              playVideoHandler={this.togglePausePlay.bind(this)}
              buttonFocusPath={PAUSE_AD_BUTTON_FOCUS}
              buttonLabel={this.state.pauseAd?.cta || i18n.get("global.adTech.pauseAd.visitCta")}
              adHandler={this.pauseAdHandler}
              isShowCta={!!this.state.pauseAd?.clickTrackingURL}
              adLabel={i18n.get("global.adTech.pauseAd.label")}
              adTagline={i18n.get("global.adTech.pauseAd.text")}
              isShowRemoveAdCTA={this.isAdRemoved}
              removeButtonFocusPath={REMOVE_AD_PAUSE_BUTTON_FOCUS_PATH}
              removeButtonLabel={i18n.get("pages.player.removeAd")}
              removeAdAction={this.removeAdAction}
            />
          ) : (
            this.state.showPauseScreen && (
              <PauseScreen
                heading={i18n.get("pages.player.youAreWatching")}
                contentTitle={this.state.title}
                seriesTitle={this.state.seriesTitle}
                episodeLabel={this.state.episodeLabel}
                contentDescription={this.state.description}
              />
            )
          )
        ) : null}
        {this.state.showEpisodesLists &&
          this.isAdUIShown === false &&
          !this.shouldShowLoading() &&
          this.getSeasonsList() &&
          this.getEpisodesList() && (
            <div
              onWheel={e => {
                this.scrollUpDown(e);
              }}
            >
              <EpisodesSelectorScreen
                seasonsList={this.getSeasonsList()}
                episodesList={this.getEpisodesList()}
                seasonSelected={this.state.tvSeasonNumber}
                episodeSelected={this.state.tvSeasonEpisodeNumber}
                onEnterPress={this.playEpisode}
                onSeasonChanged={this.seasonChanged}
                onMouseUp={this.playEpisode}
                dataSnUp={""}
                dataSnDown={""}
                fromDetailPage={true}
                fromPlayer={true}
                MagicRemoteStatus={this.wheelState === "active" ? true : false}
                showArrows={this.wheelState === "active" ? true : false}
                currentFocus={this.props.applicationState.currentFocus}
                direction={i18n.getDirection()}
                slideMarginStart={resolution.carousel.slideMarginStart.episodeSelector}
                subscriptionStatus={i18n.get("pages.detail.free")}
                isActiveUser={isActiveUser}
              />
            </div>
          )}
        {this.state.nextEpisode &&
          this.state.nextEpisode.images.screenshot &&
          this.state.nextEpisode.tvSeasonNumber &&
          this.state.nextEpisode.tvSeasonEpisodeNumber &&
          this.state.nextEpisode.title &&
          this.state.skipOutroPlay === false &&
          this.isAdUIShown === false &&
          this.state.nextEpisodePlay &&
          videoType === "series" &&
          this.state.nextEpisode && (
            <NextEpisode
              className="next-episode"
              focusPath="nextEpisode"
              imageUrl={this.state.nextEpisode.images.screenshot}
              countdownText={
                !this.state.isFreePlaybackEnded
                  ? i18n.get("pages.player.nextEpisodeWillStartIn", this.state.nextEpisodeCountDown)
                  : ""
              }
              episodeLabel={getEpisodeLabel(
                this.state.nextEpisode.tvSeasonNumber,
                this.state.nextEpisode.tvSeasonEpisodeNumber
              )}
              contentTitle={this.state.nextEpisode.title}
              nextEpisodeTitle={this.state.nextEpisode}
              onEnterPress={this.playEpisode}
              onMouseUp={this.playEpisode}
              backHandler={this.back}
              buttonLabel={i18n.get("global.back").toUpperCase()}
              position="center"
              buttonFocusPath="buttonBackNextEpisode"
            />
          )}
        {this.state.skipIntroPlay === true && this.isAdUIShown === false && videoType === "series" && (
          <ButtonSkipIntroFocus
            className="focused introbuttonfix"
            label={i18n.get("pages.player.skipIntro").toUpperCase()}
            onMouseUp={this.skipIntroAction}
            focusPath={SKIP_INTRO_BUTTON_FOCUS_PATH}
            size="small"
            buttonType="primary"
          />
        )}
        {this.state.skipOutroPlay === true &&
          videoType === "series" &&
          this.isAdUIShown === false &&
          this.state.nextEpisode && (
            <NextEpisode
              className="next-episode"
              focusPath="nextEpisode"
              imageUrl={this.state.nextEpisode.images.screenshot}
              countdownText={i18n.get("pages.player.nextEpisodeWillStartIn", this.state.skipOutroCountDown)}
              episodeLabel={getEpisodeLabel(
                this.state.nextEpisode.tvSeasonNumber,
                this.state.nextEpisode.tvSeasonEpisodeNumber
              )}
              contentTitle={this.state.nextEpisode.title}
              onEnterPress={this.skipOutroAction}
              onMouseUp={this.skipOutroAction}
              backHandler={this.dismissOutro}
              buttonLabel={i18n.get("pages.player.dismissButton").toUpperCase()}
              position="bottomRight"
              buttonFocusPath="buttonBackNextEpisode"
            />
          )}
        {!this.shouldShowLoading() &&
          this.state.openTracksAndAudio &&
          this.state.showPlayerControls &&
          this.isAdUIShown === false &&
          videoType !== "trailer" && (
            <Tracks
              audioTracks={this.state.audioTracks}
              subtitleTracks={this.state.subtitleTracks}
              audioTitle={i18n.get("pages.player.audio")}
              subtitlesTitle={i18n.get("global.subtitles")}
              onTrackSelected={this.selectTrack}
            />
          )}
        {!this.shouldShowLoading() &&
          !this.state.showEpisodesLists &&
          this.state.showPlayerControls &&
          this.isAdUIShown === false && (
            <Title
              className="zindex playerTitle"
              title={this.state.seriesTitle || this.state.title}
              episodeLabel={this.state.episodeLabel}
            />
          )}
        {!this.shouldShowLoading() &&
          this.shouldRenderPlaybackRate() &&
          this.isAdUIShown === false &&
          videoType !== "trailer" && (
            <PlaybackRate
              rate={this.state.playbackRate || undefined}
              iconName={this.playbackIconName || undefined}
              text={!this.hasThumbnails() ? i18n.get("pages.player.pressOkButtonToResume") : undefined}
            />
          )}
        {!this.shouldShowLoading() &&
          videoType !== "trailer" &&
          this.state.showFilmStrip === true &&
          this.isAdUIShown === false &&
          this.state.showPlayerControls &&
          this.state.filmstripData &&
          this.state.filmstripData.thumbnails &&
          this.state.filmstripData.thumbnails.length > 0 &&
          !isLive &&
          !this.state.playerBuffering && (
            <FilmstripFocus
              focusPath={"filmstrip"}
              thumbnails={this.state.filmstripData.thumbnails}
              initialThumbnail={
                this.state.filmstripData.thumbnails.length > this.state.currentFilmstripPosition &&
                this.state.currentFilmstripPosition
              }
              filmstripCarousel={carousel => (this.filmstrip = carousel)}
              direction={i18n.directions.LEFT_TO_RIGHT}
            />
          )}

        {!this.shouldShowLoading() &&
        this.state.isPlayerLoaded &&
        !this.state.showEpisodesLists &&
        this.state.showPlayerControls &&
        !this.isAdUIShown ? (
          <PlayerShadow style={{ zIndex: 9 }}>
            <ControlsSettingsStyled>
              <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.backHandler.bind(this)}>
                <FillBtnBack className={this.state.selectBtn === 1 ? "activePlayer" : null} />
              </ControlSettingsBtn>
              {videoType !== "trailer" && !this.state.playerBuffering && (
                <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.openLanguage.bind(this)}>
                  <FillBtnLanguage className={this.state.selectBtn === 2 ? "activePlayer" : null} />
                </ControlSettingsBtn>
              )}
              {videoType !== "trailer" && !this.state.playerBuffering && !isLive && (
                <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.playFromBegining.bind(this)}>
                  <FillBtnStart className={this.state.selectBtn === 3 ? "activePlayer" : null} />
                </ControlSettingsBtn>
              )}
              {videoType === "series" && !this.state.playerBuffering && (
                <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.openEpisodeList.bind(this)}>
                  <FillBtnEpisode className={this.state.selectBtn === 4 ? "activePlayer" : null} />
                </ControlSettingsBtn>
              )}
            </ControlsSettingsStyled>
            <LabelDiv
              style={
                i18n.getDirection() === "ltr"
                  ? { marginLeft: this.state.margin + "em" }
                  : { marginRight: this.state.margin + "em" }
              }
            >
              <LabelStyled>{this.state.textLabels[this.state.selectBtn]}</LabelStyled>
            </LabelDiv>

            {this.state.showPauseScreen === false && this.state.skipIntroPlay === false && (
              <LowerPlayerControls
                dir="ltr"
                onMouseOver={this.showBar.bind(this)}
                onMouseOut={this.showControls.bind(this)}
              >
                {this.isAdRemoved && videoType !== "trailer" && (
                  <ButtonRemoveAdStyled
                    onClick={this.removeAdAction.bind(this)}
                    selectFocusBtnAdRemoved={this.state.selectFocusBtnAdRemoved}
                  >
                    <span>{i18n.get("pages.player.removeAd")}</span>
                  </ButtonRemoveAdStyled>
                )}
                {!isLive && (
                  <PlayPauseToggle id="playpause" onClick={this.togglePausePlay.bind(this)}>
                    <ToggleBtn xmlns="http://www.w3.org/2000/svg">
                      {!this.state.isPlaying && (
                        <FillBtnPlay
                          className={
                            this.state.selectBtn === 0 && !this.state.selectFocusBtnAdRemoved ? "activePlayer" : null
                          }
                        />
                      )}
                      {this.state.isPlaying && (
                        <FillBtnPause
                          className={
                            this.state.selectBtn === 0 && !this.state.selectFocusBtnAdRemoved ? "activePlayer" : null
                          }
                        />
                      )}
                    </ToggleBtn>
                  </PlayPauseToggle>
                )}
                {!isLive && (
                  <CurrentPlay currentState={this.state.currentTime.lastIndexOf(":")}>
                    <CurrentAndTotalPlaySpan>
                      {this.state.currentTime !== "NaNNaN:NaN" ? this.state.currentTime : "00:00"}
                    </CurrentAndTotalPlaySpan>
                  </CurrentPlay>
                )}
                <ProgressBarContainer>
                  <ProgressBar value={this.state.seekedTime} max={this.state.totalTimeInSeconds} />
                  {this.adBreaksStartTimes.length !== 0 && this.adMargin && (
                    <AdBreaksListStyled>
                      {this.adMargin.map((margin, i) => (
                        <AdBreaksStyled key={i} margin={margin} isAdExist={this.isAdexists() ? true : false} />
                      ))}
                    </AdBreaksListStyled>
                  )}
                </ProgressBarContainer>
                {!isLive && (
                  <TotalPlayTime>
                    <CurrentAndTotalPlaySpan>{this.state.duration}</CurrentAndTotalPlaySpan>
                  </TotalPlayTime>
                )}
              </LowerPlayerControls>
            )}
          </PlayerShadow>
        ) : (
          !this.shouldShowLoading() &&
          this.state.isPlayerLoaded &&
          !this.state.showEpisodesLists &&
          this.isAdUIShown && (
            <PlayerShadowAds style={{ zIndex: 9 }}>
              <LowerPlayerControlsAds dir="ltr">
                <ButtonsAdsStyled className={"adsButtons"}>
                  {this.adRoutingURL && this.adRoutingURL.length <= 2950 && (
                    <AdButtonFocus
                      focusPath={SEND_TO_PHONE}
                      isPlayerAdButton={true}
                      label={i18n.get("pages.player.snedToPhone").toUpperCase()}
                      icon={
                        this.props.applicationState.currentFocus === SEND_TO_PHONE
                          ? SEND_TO_PHONE_ICON_FOCUS
                          : SEND_TO_PHONE_ICON
                      }
                      buttonType="primary"
                      onEnterPress={this.openADSponsorAction}
                      onMouseUp={this.openADSponsorAction}
                    />
                  )}
                  {!isLive && this.isSkipable && (
                    <SkipAdButtonFocus
                      disabled={this.isSkipBtnDisabled}
                      focusPath={SKIP_AD}
                      isPlayerAdButton={true}
                      label={i18n.get("pages.player.skipAd").toUpperCase()}
                      icon={this.props.applicationState.currentFocus === SKIP_AD ? SKIP_AD_ICON_FOCUS : SKIP_AD_ICON}
                      buttonType="primary"
                      onEnterPress={this.skipAdAction}
                      onMouseUp={this.skipAdAction}
                    />
                  )}
                  {this.isAdRemoved && (
                    <AdButtonRemoveFocus
                      focusPath={REMOVE_AD_BUTTON}
                      isPlayerAdButton={true}
                      label={i18n.get("pages.player.removeAd")}
                      onMouseUp={this.removeAdAction}
                      onEnterPress={this.removeAdAction}
                      icon={null}
                      buttonType="primary"
                    />
                  )}
                </ButtonsAdsStyled>
                <ProgressBarContainerAd>
                  <ProgressBarAd value={this.adSeekTime} max={this.adDurationinSeconds} />
                </ProgressBarContainerAd>
                <AdInfoStyled>
                  <AdTag text={`${"&nbsp" + i18n.get("pages.player.ad") + "&nbsp"}`} />
                  <AdTextStyled>
                    {this.appFlow === "rtl" ? (
                      <>
                        <span> {this.totalAdsInAdBreak}</span>
                        <p>{i18n.get("pages.player.of")}</p>
                        <span>
                          {this.adCounter + 1 > this.totalAdsInAdBreak ? this.totalAdsInAdBreak : this.adCounter + 1}
                        </span>
                      </>
                    ) : (
                      <>
                        <span>
                          {this.adCounter + 1 > this.totalAdsInAdBreak ? this.totalAdsInAdBreak : this.adCounter + 1}
                        </span>
                        <p>{i18n.get("pages.player.of")}</p>
                        <span> {this.totalAdsInAdBreak}</span>
                      </>
                    )}
                    <AdDotStyled>&bull;</AdDotStyled> {this.adDuration}
                  </AdTextStyled>
                </AdInfoStyled>
              </LowerPlayerControlsAds>
            </PlayerShadowAds>
          )
        )}

        {!this.shouldShowLoading() && this.showVideoCommerceUI && this.filteredVCData && (
          <div
            onWheel={e => {
              this.scrollUpDown(e);
            }}
          >
            <VideoCommerceList
              list={this.filteredVCData}
              playerObj={this.player}
              direction={this.appFlow}
              showQRCodeModal={this.showQRCodeModal}
              wheelState={this.wheelState}
              vcHandler={this.VideoCommerceHandler}
              vcBackHandler={this.onBack.bind(this)}
            />
          </div>
        )}
        <PlayerDiv id="av-player" isRTL={this.appFlow === "rtl" ? true : false} />
      </Wrapper>
    );
  }
}
export default withAppState(withSubtheme(PlayerBitMovin));
